/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Sifly Cloud API Documentation
 * Backend APIs for Sifly Cloud: accounts, drone command & telemetry, video streaming, integrations, and more.
 * OpenAPI spec version: v1
 */
import {
  z as zod
} from 'zod';

/**
 * API to request access to an organization admin
 */
export const accountAccessRequestCreateBody = zod.object({
  "organization": zod.number().nullish(),
  "admin_email": zod.email().optional()
})


/**
 * @summary List all Addresses
 */
export const accountAddressesListResponseStreetAddress1Max = 255;
export const accountAddressesListResponseStreetAddress2Max = 255;
export const accountAddressesListResponseCityMax = 255;
export const accountAddressesListResponseZipCodeMax = 20;
export const accountAddressesListResponseStateMax = 255;
export const accountAddressesListResponseCountryMax = 255;


export const accountAddressesListResponseItem = zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountAddressesListResponseStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesListResponseStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesListResponseCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesListResponseZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesListResponseStateMax).nullish(),
  "country": zod.string().max(accountAddressesListResponseCountryMax).nullish()
})
export const accountAddressesListResponse = zod.array(accountAddressesListResponseItem)


/**
 * @summary Create a new Address
 */
export const accountAddressesCreateBodyStreetAddress1Max = 255;
export const accountAddressesCreateBodyStreetAddress2Max = 255;
export const accountAddressesCreateBodyCityMax = 255;
export const accountAddressesCreateBodyZipCodeMax = 20;
export const accountAddressesCreateBodyStateMax = 255;
export const accountAddressesCreateBodyCountryMax = 255;


export const accountAddressesCreateBody = zod.object({
  "street_address_1": zod.string().max(accountAddressesCreateBodyStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesCreateBodyStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesCreateBodyCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesCreateBodyZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesCreateBodyStateMax).nullish(),
  "country": zod.string().max(accountAddressesCreateBodyCountryMax).nullish()
})


/**
 * @summary Retrieve a Address
 */
export const accountAddressesReadResponseStreetAddress1Max = 255;
export const accountAddressesReadResponseStreetAddress2Max = 255;
export const accountAddressesReadResponseCityMax = 255;
export const accountAddressesReadResponseZipCodeMax = 20;
export const accountAddressesReadResponseStateMax = 255;
export const accountAddressesReadResponseCountryMax = 255;


export const accountAddressesReadResponse = zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountAddressesReadResponseStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesReadResponseStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesReadResponseCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesReadResponseZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesReadResponseStateMax).nullish(),
  "country": zod.string().max(accountAddressesReadResponseCountryMax).nullish()
})


/**
 * @summary Update a Address
 */
export const accountAddressesUpdateBodyStreetAddress1Max = 255;
export const accountAddressesUpdateBodyStreetAddress2Max = 255;
export const accountAddressesUpdateBodyCityMax = 255;
export const accountAddressesUpdateBodyZipCodeMax = 20;
export const accountAddressesUpdateBodyStateMax = 255;
export const accountAddressesUpdateBodyCountryMax = 255;


export const accountAddressesUpdateBody = zod.object({
  "street_address_1": zod.string().max(accountAddressesUpdateBodyStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesUpdateBodyStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesUpdateBodyCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesUpdateBodyZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesUpdateBodyStateMax).nullish(),
  "country": zod.string().max(accountAddressesUpdateBodyCountryMax).nullish()
})

export const accountAddressesUpdateResponseStreetAddress1Max = 255;
export const accountAddressesUpdateResponseStreetAddress2Max = 255;
export const accountAddressesUpdateResponseCityMax = 255;
export const accountAddressesUpdateResponseZipCodeMax = 20;
export const accountAddressesUpdateResponseStateMax = 255;
export const accountAddressesUpdateResponseCountryMax = 255;


export const accountAddressesUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountAddressesUpdateResponseStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesUpdateResponseStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesUpdateResponseCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesUpdateResponseZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesUpdateResponseStateMax).nullish(),
  "country": zod.string().max(accountAddressesUpdateResponseCountryMax).nullish()
})


/**
 * @summary Partially update a Address
 */
export const accountAddressesPartialUpdateBodyStreetAddress1Max = 255;
export const accountAddressesPartialUpdateBodyStreetAddress2Max = 255;
export const accountAddressesPartialUpdateBodyCityMax = 255;
export const accountAddressesPartialUpdateBodyZipCodeMax = 20;
export const accountAddressesPartialUpdateBodyStateMax = 255;
export const accountAddressesPartialUpdateBodyCountryMax = 255;


export const accountAddressesPartialUpdateBody = zod.object({
  "street_address_1": zod.string().max(accountAddressesPartialUpdateBodyStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesPartialUpdateBodyStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesPartialUpdateBodyCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesPartialUpdateBodyZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesPartialUpdateBodyStateMax).nullish(),
  "country": zod.string().max(accountAddressesPartialUpdateBodyCountryMax).nullish()
})

export const accountAddressesPartialUpdateResponseStreetAddress1Max = 255;
export const accountAddressesPartialUpdateResponseStreetAddress2Max = 255;
export const accountAddressesPartialUpdateResponseCityMax = 255;
export const accountAddressesPartialUpdateResponseZipCodeMax = 20;
export const accountAddressesPartialUpdateResponseStateMax = 255;
export const accountAddressesPartialUpdateResponseCountryMax = 255;


export const accountAddressesPartialUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountAddressesPartialUpdateResponseStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountAddressesPartialUpdateResponseStreetAddress2Max).nullish(),
  "city": zod.string().max(accountAddressesPartialUpdateResponseCityMax).nullish(),
  "zip_code": zod.string().max(accountAddressesPartialUpdateResponseZipCodeMax).nullish(),
  "state": zod.string().max(accountAddressesPartialUpdateResponseStateMax).nullish(),
  "country": zod.string().max(accountAddressesPartialUpdateResponseCountryMax).nullish()
})


/**
 * This API allows users to update their preferred color scheme.
 * @summary Update preferred color scheme options
 */
export const accountApiUpdateColorSchemePreferencePartialUpdateBody = zod.object({
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']).describe('Preferred color scheme option')
})


/**
 * Retrieve a list of all companies/organizations that the authenticated user has access to. If the X-Mobile-Access-Key header is provided with a valid key, the response will include organization device keys (organization_device_private_key and organization_device_token).
 * @summary List all companies
 */
export const accountCompaniesListHeader = zod.object({
  "X-Mobile-Access-Key": zod.string().optional().describe('Mobile client access key. When provided with a valid key, device keys will be included in the response.')
})

export const accountCompaniesListResponseDataItemAddressStreetAddress1Max = 255;
export const accountCompaniesListResponseDataItemAddressStreetAddress2Max = 255;
export const accountCompaniesListResponseDataItemAddressCityMax = 255;
export const accountCompaniesListResponseDataItemAddressZipCodeMax = 20;
export const accountCompaniesListResponseDataItemAddressStateMax = 255;
export const accountCompaniesListResponseDataItemAddressCountryMax = 255;
export const accountCompaniesListResponseDataItemNameMax = 255;
export const accountCompaniesListResponseDataItemIndustryMax = 255;


export const accountCompaniesListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesListResponseDataItemAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesListResponseDataItemAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesListResponseDataItemAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesListResponseDataItemAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesListResponseDataItemAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesListResponseDataItemAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "owner": zod.string().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountCompaniesListResponseDataItemNameMax),
  "industry": zod.string().max(accountCompaniesListResponseDataItemIndustryMax).nullish()
}))
})


/**
 * @summary Create a new company
 */
export const accountCompaniesCreateBodyAddressStreetAddress1Max = 255;
export const accountCompaniesCreateBodyAddressStreetAddress2Max = 255;
export const accountCompaniesCreateBodyAddressCityMax = 255;
export const accountCompaniesCreateBodyAddressZipCodeMax = 20;
export const accountCompaniesCreateBodyAddressStateMax = 255;
export const accountCompaniesCreateBodyAddressCountryMax = 255;
export const accountCompaniesCreateBodyNameMax = 255;
export const accountCompaniesCreateBodyIndustryMax = 255;


export const accountCompaniesCreateBody = zod.object({
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesCreateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesCreateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesCreateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesCreateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesCreateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesCreateBodyAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "name": zod.string().min(1).max(accountCompaniesCreateBodyNameMax),
  "industry": zod.string().max(accountCompaniesCreateBodyIndustryMax).nullish()
})


/**
 * @summary Retrieve a company
 */
export const accountCompaniesReadResponseDataAddressStreetAddress1Max = 255;
export const accountCompaniesReadResponseDataAddressStreetAddress2Max = 255;
export const accountCompaniesReadResponseDataAddressCityMax = 255;
export const accountCompaniesReadResponseDataAddressZipCodeMax = 20;
export const accountCompaniesReadResponseDataAddressStateMax = 255;
export const accountCompaniesReadResponseDataAddressCountryMax = 255;
export const accountCompaniesReadResponseDataNameMax = 255;
export const accountCompaniesReadResponseDataIndustryMax = 255;


export const accountCompaniesReadResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesReadResponseDataAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesReadResponseDataAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesReadResponseDataAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesReadResponseDataAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesReadResponseDataAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesReadResponseDataAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "owner": zod.string().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountCompaniesReadResponseDataNameMax),
  "industry": zod.string().max(accountCompaniesReadResponseDataIndustryMax).nullish()
})
})


/**
 * @summary Update a company
 */
export const accountCompaniesUpdateBodyAddressStreetAddress1Max = 255;
export const accountCompaniesUpdateBodyAddressStreetAddress2Max = 255;
export const accountCompaniesUpdateBodyAddressCityMax = 255;
export const accountCompaniesUpdateBodyAddressZipCodeMax = 20;
export const accountCompaniesUpdateBodyAddressStateMax = 255;
export const accountCompaniesUpdateBodyAddressCountryMax = 255;
export const accountCompaniesUpdateBodyNameMax = 255;
export const accountCompaniesUpdateBodyIndustryMax = 255;


export const accountCompaniesUpdateBody = zod.object({
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesUpdateBodyAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "name": zod.string().min(1).max(accountCompaniesUpdateBodyNameMax),
  "industry": zod.string().max(accountCompaniesUpdateBodyIndustryMax).nullish()
})

export const accountCompaniesUpdateResponseDataAddressStreetAddress1Max = 255;
export const accountCompaniesUpdateResponseDataAddressStreetAddress2Max = 255;
export const accountCompaniesUpdateResponseDataAddressCityMax = 255;
export const accountCompaniesUpdateResponseDataAddressZipCodeMax = 20;
export const accountCompaniesUpdateResponseDataAddressStateMax = 255;
export const accountCompaniesUpdateResponseDataAddressCountryMax = 255;
export const accountCompaniesUpdateResponseDataNameMax = 255;
export const accountCompaniesUpdateResponseDataIndustryMax = 255;


export const accountCompaniesUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesUpdateResponseDataAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesUpdateResponseDataAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesUpdateResponseDataAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesUpdateResponseDataAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesUpdateResponseDataAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesUpdateResponseDataAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "owner": zod.string().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountCompaniesUpdateResponseDataNameMax),
  "industry": zod.string().max(accountCompaniesUpdateResponseDataIndustryMax).nullish()
})
})


/**
 * @summary Partially update a company
 */
export const accountCompaniesPartialUpdateBodyAddressStreetAddress1Max = 255;
export const accountCompaniesPartialUpdateBodyAddressStreetAddress2Max = 255;
export const accountCompaniesPartialUpdateBodyAddressCityMax = 255;
export const accountCompaniesPartialUpdateBodyAddressZipCodeMax = 20;
export const accountCompaniesPartialUpdateBodyAddressStateMax = 255;
export const accountCompaniesPartialUpdateBodyAddressCountryMax = 255;
export const accountCompaniesPartialUpdateBodyNameMax = 255;
export const accountCompaniesPartialUpdateBodyIndustryMax = 255;


export const accountCompaniesPartialUpdateBody = zod.object({
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesPartialUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesPartialUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesPartialUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesPartialUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesPartialUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesPartialUpdateBodyAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "name": zod.string().min(1).max(accountCompaniesPartialUpdateBodyNameMax),
  "industry": zod.string().max(accountCompaniesPartialUpdateBodyIndustryMax).nullish()
})

export const accountCompaniesPartialUpdateResponseDataAddressStreetAddress1Max = 255;
export const accountCompaniesPartialUpdateResponseDataAddressStreetAddress2Max = 255;
export const accountCompaniesPartialUpdateResponseDataAddressCityMax = 255;
export const accountCompaniesPartialUpdateResponseDataAddressZipCodeMax = 20;
export const accountCompaniesPartialUpdateResponseDataAddressStateMax = 255;
export const accountCompaniesPartialUpdateResponseDataAddressCountryMax = 255;
export const accountCompaniesPartialUpdateResponseDataNameMax = 255;
export const accountCompaniesPartialUpdateResponseDataIndustryMax = 255;


export const accountCompaniesPartialUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCompaniesPartialUpdateResponseDataAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCompaniesPartialUpdateResponseDataAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCompaniesPartialUpdateResponseDataAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCompaniesPartialUpdateResponseDataAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCompaniesPartialUpdateResponseDataAddressStateMax).nullish(),
  "country": zod.string().max(accountCompaniesPartialUpdateResponseDataAddressCountryMax).nullish()
}).optional(),
  "owner_id": zod.number(),
  "owner": zod.string().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountCompaniesPartialUpdateResponseDataNameMax),
  "industry": zod.string().max(accountCompaniesPartialUpdateResponseDataIndustryMax).nullish()
})
})


/**
 * Allow authenticated users to partially update their own profile.
 * @summary Get the current user
 */
export const accountCurrentUserReadResponseUsernameMax = 50;
export const accountCurrentUserReadResponseFirstNameMax = 150;
export const accountCurrentUserReadResponseLastNameMax = 150;
export const accountCurrentUserReadResponseEmailMax = 254;
export const accountCurrentUserReadResponseIdpIdMax = 255;
export const accountCurrentUserReadResponseAddressStreetAddress1Max = 255;
export const accountCurrentUserReadResponseAddressStreetAddress2Max = 255;
export const accountCurrentUserReadResponseAddressCityMax = 255;
export const accountCurrentUserReadResponseAddressZipCodeMax = 20;
export const accountCurrentUserReadResponseAddressStateMax = 255;
export const accountCurrentUserReadResponseAddressCountryMax = 255;
export const accountCurrentUserReadResponsePermissionsItemNameMax = 255;


export const accountCurrentUserReadResponse = zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountCurrentUserReadResponseUsernameMax),
  "first_name": zod.string().max(accountCurrentUserReadResponseFirstNameMax).nullable(),
  "last_name": zod.string().max(accountCurrentUserReadResponseLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountCurrentUserReadResponseEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountCurrentUserReadResponseIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCurrentUserReadResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCurrentUserReadResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCurrentUserReadResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCurrentUserReadResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCurrentUserReadResponseAddressStateMax).nullish(),
  "country": zod.string().max(accountCurrentUserReadResponseAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountCurrentUserReadResponsePermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})


/**
 * Allow authenticated users to partially update their own profile.
 * @summary Partially update the current user
 */
export const accountCurrentUserPartialUpdateBodyUsernameMax = 50;
export const accountCurrentUserPartialUpdateBodyFirstNameMax = 150;
export const accountCurrentUserPartialUpdateBodyLastNameMax = 150;
export const accountCurrentUserPartialUpdateBodyEmailMax = 254;
export const accountCurrentUserPartialUpdateBodyIdpIdMax = 255;
export const accountCurrentUserPartialUpdateBodyAddressStreetAddress1Max = 255;
export const accountCurrentUserPartialUpdateBodyAddressStreetAddress2Max = 255;
export const accountCurrentUserPartialUpdateBodyAddressCityMax = 255;
export const accountCurrentUserPartialUpdateBodyAddressZipCodeMax = 20;
export const accountCurrentUserPartialUpdateBodyAddressStateMax = 255;
export const accountCurrentUserPartialUpdateBodyAddressCountryMax = 255;


export const accountCurrentUserPartialUpdateBody = zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountCurrentUserPartialUpdateBodyUsernameMax),
  "first_name": zod.string().max(accountCurrentUserPartialUpdateBodyFirstNameMax).nullable(),
  "last_name": zod.string().max(accountCurrentUserPartialUpdateBodyLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountCurrentUserPartialUpdateBodyEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountCurrentUserPartialUpdateBodyIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCurrentUserPartialUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCurrentUserPartialUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCurrentUserPartialUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCurrentUserPartialUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCurrentUserPartialUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountCurrentUserPartialUpdateBodyAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable()
})

export const accountCurrentUserPartialUpdateResponseUsernameMax = 50;
export const accountCurrentUserPartialUpdateResponseFirstNameMax = 150;
export const accountCurrentUserPartialUpdateResponseLastNameMax = 150;
export const accountCurrentUserPartialUpdateResponseEmailMax = 254;
export const accountCurrentUserPartialUpdateResponseIdpIdMax = 255;
export const accountCurrentUserPartialUpdateResponseAddressStreetAddress1Max = 255;
export const accountCurrentUserPartialUpdateResponseAddressStreetAddress2Max = 255;
export const accountCurrentUserPartialUpdateResponseAddressCityMax = 255;
export const accountCurrentUserPartialUpdateResponseAddressZipCodeMax = 20;
export const accountCurrentUserPartialUpdateResponseAddressStateMax = 255;
export const accountCurrentUserPartialUpdateResponseAddressCountryMax = 255;
export const accountCurrentUserPartialUpdateResponsePermissionsItemNameMax = 255;


export const accountCurrentUserPartialUpdateResponse = zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountCurrentUserPartialUpdateResponseUsernameMax),
  "first_name": zod.string().max(accountCurrentUserPartialUpdateResponseFirstNameMax).nullable(),
  "last_name": zod.string().max(accountCurrentUserPartialUpdateResponseLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountCurrentUserPartialUpdateResponseEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountCurrentUserPartialUpdateResponseIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountCurrentUserPartialUpdateResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountCurrentUserPartialUpdateResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountCurrentUserPartialUpdateResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountCurrentUserPartialUpdateResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountCurrentUserPartialUpdateResponseAddressStateMax).nullish(),
  "country": zod.string().max(accountCurrentUserPartialUpdateResponseAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountCurrentUserPartialUpdateResponsePermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})


/**
 * API endpoint that retrieves customer support contact information including phone number and email.
 */
export const accountCustomerSupportListResponsePhoneNumberMax = 20;
export const accountCustomerSupportListResponseEmailMax = 254;


export const accountCustomerSupportListResponse = zod.object({
  "phone_number": zod.string().min(1).max(accountCustomerSupportListResponsePhoneNumberMax).describe('Customer support phone number'),
  "email": zod.email().min(1).max(accountCustomerSupportListResponseEmailMax).describe('Customer support email address')
})


/**
 * Sets the CSRF cookie and returns the CSRF token.
 */
export const getCsrfTokenResponse = zod.object({
  "csrfToken": zod.string().min(1)
})


/**
 * API endpoint for user login. Validates user credentials and returns user profile if successful.
 */
export const accountLoginCreateBody = zod.object({
  "email": zod.email().min(1),
  "password": zod.string().min(1)
})

export const accountLoginCreateResponseDataUserUsernameMax = 50;
export const accountLoginCreateResponseDataUserFirstNameMax = 150;
export const accountLoginCreateResponseDataUserLastNameMax = 150;
export const accountLoginCreateResponseDataUserEmailMax = 254;
export const accountLoginCreateResponseDataUserIdpIdMax = 255;
export const accountLoginCreateResponseDataUserAddressStreetAddress1Max = 255;
export const accountLoginCreateResponseDataUserAddressStreetAddress2Max = 255;
export const accountLoginCreateResponseDataUserAddressCityMax = 255;
export const accountLoginCreateResponseDataUserAddressZipCodeMax = 20;
export const accountLoginCreateResponseDataUserAddressStateMax = 255;
export const accountLoginCreateResponseDataUserAddressCountryMax = 255;
export const accountLoginCreateResponseDataUserPermissionsItemNameMax = 255;


export const accountLoginCreateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "user": zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountLoginCreateResponseDataUserUsernameMax),
  "first_name": zod.string().max(accountLoginCreateResponseDataUserFirstNameMax).nullable(),
  "last_name": zod.string().max(accountLoginCreateResponseDataUserLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountLoginCreateResponseDataUserEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountLoginCreateResponseDataUserIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountLoginCreateResponseDataUserAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountLoginCreateResponseDataUserAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountLoginCreateResponseDataUserAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountLoginCreateResponseDataUserAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountLoginCreateResponseDataUserAddressStateMax).nullish(),
  "country": zod.string().max(accountLoginCreateResponseDataUserAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountLoginCreateResponseDataUserPermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})
})
})


/**
 * Logs out the current authenticated user, destroying the session.
 */
export const logoutUserResponse = zod.object({
  "status": zod.number().describe('HTTP status code, e.g., 200'),
  "message": zod.string().min(1).describe('Status message')
})


/**
 * This API retrieves both users associated with a specific organization and invitations sent to users to join the organization.
 * @summary Retrieve users and invitations for an organization
 */
export const accountOrganizationsGetResponseDataUsersItemEmailMax = 254;
export const accountOrganizationsGetResponseDataUsersItemFirstNameMax = 150;
export const accountOrganizationsGetResponseDataUsersItemLastNameMax = 150;


export const accountOrganizationsGetResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "users": zod.array(zod.object({
  "id": zod.number().optional(),
  "email": zod.email().min(1).max(accountOrganizationsGetResponseDataUsersItemEmailMax),
  "first_name": zod.string().max(accountOrganizationsGetResponseDataUsersItemFirstNameMax).optional(),
  "last_name": zod.string().max(accountOrganizationsGetResponseDataUsersItemLastNameMax).optional(),
  "roles": zod.array(zod.string()).optional(),
  "is_owner": zod.boolean().optional()
})),
  "invitations": zod.array(zod.object({
  "id": zod.number().optional(),
  "user": zod.number(),
  "user_email": zod.string().optional(),
  "content_type": zod.string(),
  "object_id": zod.number(),
  "token": zod.uuid().optional(),
  "is_accepted": zod.boolean().optional(),
  "roles": zod.string().optional()
}))
})
})


/**
 * API view to handle password reset requests.
 * @summary Request Password Reset
 */
export const accountRequestResetPasswordCreateBody = zod.object({
  "email": zod.email().describe('User\'s email address')
})


/**
 * API view to handle password resets using a token.
 * @summary Reset Password
 */
export const accountResetPasswordCreateBody = zod.object({
  "token": zod.string().describe('Reset token'),
  "new_password": zod.string().describe('New password')
})


/**
 * @summary List all roles
 */
export const accountRolesListResponseNameMax = 255;


export const accountRolesListResponseItem = zod.object({
  "id": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountRolesListResponseNameMax),
  "description": zod.string().min(1)
})
export const accountRolesListResponse = zod.array(accountRolesListResponseItem)


/**
 * @summary Create a new role
 */
export const accountRolesCreateBodyNameMax = 255;


export const accountRolesCreateBody = zod.object({
  "name": zod.string().min(1).max(accountRolesCreateBodyNameMax),
  "description": zod.string().min(1)
})


/**
 * @summary Retrieve a role
 */
export const accountRolesReadResponseNameMax = 255;


export const accountRolesReadResponse = zod.object({
  "id": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountRolesReadResponseNameMax),
  "description": zod.string().min(1)
})


/**
 * @summary Update a role
 */
export const accountRolesUpdateBodyNameMax = 255;


export const accountRolesUpdateBody = zod.object({
  "name": zod.string().min(1).max(accountRolesUpdateBodyNameMax),
  "description": zod.string().min(1)
})

export const accountRolesUpdateResponseNameMax = 255;


export const accountRolesUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountRolesUpdateResponseNameMax),
  "description": zod.string().min(1)
})


/**
 * @summary Partially update a role
 */
export const accountRolesPartialUpdateBodyNameMax = 255;


export const accountRolesPartialUpdateBody = zod.object({
  "name": zod.string().min(1).max(accountRolesPartialUpdateBodyNameMax),
  "description": zod.string().min(1)
})

export const accountRolesPartialUpdateResponseNameMax = 255;


export const accountRolesPartialUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(accountRolesPartialUpdateResponseNameMax),
  "description": zod.string().min(1)
})


export const accountSendInvitationCreateBody = zod.object({
  "user": zod.number(),
  "content_type": zod.string(),
  "object_id": zod.number()
})


/**
 * API view that either signs up a new user or updates an existing user's profile.
 */
export const accountSignupCreateBodyAddressStreetAddress1Max = 255;
export const accountSignupCreateBodyAddressStreetAddress2Max = 255;
export const accountSignupCreateBodyAddressCityMax = 255;
export const accountSignupCreateBodyAddressZipCodeMax = 20;
export const accountSignupCreateBodyAddressStateMax = 255;
export const accountSignupCreateBodyAddressCountryMax = 255;


export const accountSignupCreateBody = zod.object({
  "email": zod.email().min(1),
  "password": zod.string().min(1),
  "first_name": zod.string().optional(),
  "last_name": zod.string().optional(),
  "username": zod.string().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountSignupCreateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountSignupCreateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountSignupCreateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountSignupCreateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountSignupCreateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountSignupCreateBodyAddressCountryMax).nullish()
}).optional()
})


/**
 * @summary List all user roles
 */
export const accountUserrolesListResponseItem = zod.object({
  "id": zod.number().optional(),
  "user": zod.number(),
  "role": zod.number(),
  "organization": zod.number(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})
export const accountUserrolesListResponse = zod.array(accountUserrolesListResponseItem)


/**
 * @summary Create a new user role
 */
export const accountUserrolesCreateBody = zod.object({
  "user_id": zod.number().describe('ID of the user to assign the role'),
  "role_id": zod.number().describe('ID of the role to assign'),
  "organization_id": zod.number().describe('ID of the organization the role is assigned within')
})


/**
 * @summary Bulk update roles for multiple users
 */
export const accountUserrolesBulkUpdateBody = zod.object({
  "ids": zod.array(zod.number()).describe('Array of user role IDs to update'),
  "role_id": zod.number().describe('Role ID to assign to the users')
})

export const accountUserrolesBulkUpdateResponse = zod.object({
  "ids": zod.array(zod.number()).describe('Array of user role IDs to update'),
  "role_id": zod.number().describe('Role ID to assign to the users')
})


/**
 * @summary Retrieve a user role
 */
export const accountUserrolesReadResponse = zod.object({
  "id": zod.number().optional(),
  "user": zod.number(),
  "role": zod.number(),
  "organization": zod.number(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


/**
 * @summary Update a user role
 */
export const accountUserrolesUpdateBody = zod.object({
  "user": zod.number(),
  "role": zod.number(),
  "organization": zod.number()
})

export const accountUserrolesUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "user": zod.number(),
  "role": zod.number(),
  "organization": zod.number(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


/**
 * @summary Partially update a user role
 */
export const accountUserrolesPartialUpdateBody = zod.object({
  "user": zod.number(),
  "role": zod.number(),
  "organization": zod.number()
})

export const accountUserrolesPartialUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "user": zod.number(),
  "role": zod.number(),
  "organization": zod.number(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


/**
 * ViewSet for managing user operations including CRUD operations,
password changes, and organization management.
 */
export const accountUsersListResponseUsernameMax = 50;
export const accountUsersListResponseFirstNameMax = 150;
export const accountUsersListResponseLastNameMax = 150;
export const accountUsersListResponseEmailMax = 254;
export const accountUsersListResponseIdpIdMax = 255;
export const accountUsersListResponseAddressStreetAddress1Max = 255;
export const accountUsersListResponseAddressStreetAddress2Max = 255;
export const accountUsersListResponseAddressCityMax = 255;
export const accountUsersListResponseAddressZipCodeMax = 20;
export const accountUsersListResponseAddressStateMax = 255;
export const accountUsersListResponseAddressCountryMax = 255;
export const accountUsersListResponsePermissionsItemNameMax = 255;


export const accountUsersListResponseItem = zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountUsersListResponseUsernameMax),
  "first_name": zod.string().max(accountUsersListResponseFirstNameMax).nullable(),
  "last_name": zod.string().max(accountUsersListResponseLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountUsersListResponseEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountUsersListResponseIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersListResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersListResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersListResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersListResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersListResponseAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersListResponseAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountUsersListResponsePermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})
export const accountUsersListResponse = zod.array(accountUsersListResponseItem)


/**
 * Create a new user account in the system. Requires valid user data including email and password.
 */
export const accountUsersCreateBodyUsernameMax = 50;
export const accountUsersCreateBodyFirstNameMax = 150;
export const accountUsersCreateBodyLastNameMax = 150;
export const accountUsersCreateBodyEmailMax = 254;
export const accountUsersCreateBodyPasswordMax = 128;
export const accountUsersCreateBodyIdpIdMax = 255;
export const accountUsersCreateBodyAddressStreetAddress1Max = 255;
export const accountUsersCreateBodyAddressStreetAddress2Max = 255;
export const accountUsersCreateBodyAddressCityMax = 255;
export const accountUsersCreateBodyAddressZipCodeMax = 20;
export const accountUsersCreateBodyAddressStateMax = 255;
export const accountUsersCreateBodyAddressCountryMax = 255;


export const accountUsersCreateBody = zod.object({
  "username": zod.string().min(1).max(accountUsersCreateBodyUsernameMax),
  "first_name": zod.string().max(accountUsersCreateBodyFirstNameMax).nullish(),
  "last_name": zod.string().max(accountUsersCreateBodyLastNameMax).nullish(),
  "email": zod.email().min(1).max(accountUsersCreateBodyEmailMax),
  "password": zod.string().min(1).max(accountUsersCreateBodyPasswordMax),
  "preferred_language": zod.enum(['en', 'es']).optional(),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']).optional(),
  "idp_id": zod.string().max(accountUsersCreateBodyIdpIdMax).nullish(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersCreateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersCreateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersCreateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersCreateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersCreateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersCreateBodyAddressCountryMax).nullish()
}).optional()
})


/**
 * Remove a specific organization from multiple users at once. Also handles deletion of pending invitations for the specified organization.
 */
export const accountUsersBulkRemoveOrganizationBody = zod.object({
  "ids": zod.array(zod.number()).describe('Array of user IDs'),
  "org_id": zod.number().describe('Organization ID')
})

export const accountUsersBulkRemoveOrganizationResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "message": zod.string().min(1)
})
})


/**
 * Retrieve detailed information for a specific user by their ID.
 */
export const accountUsersReadResponseDataUserUsernameMax = 50;
export const accountUsersReadResponseDataUserFirstNameMax = 150;
export const accountUsersReadResponseDataUserLastNameMax = 150;
export const accountUsersReadResponseDataUserEmailMax = 254;
export const accountUsersReadResponseDataUserIdpIdMax = 255;
export const accountUsersReadResponseDataUserAddressStreetAddress1Max = 255;
export const accountUsersReadResponseDataUserAddressStreetAddress2Max = 255;
export const accountUsersReadResponseDataUserAddressCityMax = 255;
export const accountUsersReadResponseDataUserAddressZipCodeMax = 20;
export const accountUsersReadResponseDataUserAddressStateMax = 255;
export const accountUsersReadResponseDataUserAddressCountryMax = 255;
export const accountUsersReadResponseDataUserPermissionsItemNameMax = 255;


export const accountUsersReadResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "user": zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountUsersReadResponseDataUserUsernameMax),
  "first_name": zod.string().max(accountUsersReadResponseDataUserFirstNameMax).nullable(),
  "last_name": zod.string().max(accountUsersReadResponseDataUserLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountUsersReadResponseDataUserEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountUsersReadResponseDataUserIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersReadResponseDataUserAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersReadResponseDataUserAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersReadResponseDataUserAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersReadResponseDataUserAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersReadResponseDataUserAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersReadResponseDataUserAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountUsersReadResponseDataUserPermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})
})
})


/**
 * Update all fields(excluding username and password) of a specific user.
 */
export const accountUsersUpdateBodyFirstNameMax = 150;
export const accountUsersUpdateBodyLastNameMax = 150;
export const accountUsersUpdateBodyEmailMax = 254;
export const accountUsersUpdateBodyAddressStreetAddress1Max = 255;
export const accountUsersUpdateBodyAddressStreetAddress2Max = 255;
export const accountUsersUpdateBodyAddressCityMax = 255;
export const accountUsersUpdateBodyAddressZipCodeMax = 20;
export const accountUsersUpdateBodyAddressStateMax = 255;
export const accountUsersUpdateBodyAddressCountryMax = 255;


export const accountUsersUpdateBody = zod.object({
  "first_name": zod.string().max(accountUsersUpdateBodyFirstNameMax).optional(),
  "last_name": zod.string().max(accountUsersUpdateBodyLastNameMax).optional(),
  "email": zod.email().min(1).max(accountUsersUpdateBodyEmailMax).optional(),
  "preferred_language": zod.enum(['en', 'es']).optional(),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']).optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersUpdateBodyAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()).optional(),
  "last_selected_org": zod.number().nullish()
})

export const accountUsersUpdateResponseDataUserUsernameMax = 50;
export const accountUsersUpdateResponseDataUserFirstNameMax = 150;
export const accountUsersUpdateResponseDataUserLastNameMax = 150;
export const accountUsersUpdateResponseDataUserEmailMax = 254;
export const accountUsersUpdateResponseDataUserIdpIdMax = 255;
export const accountUsersUpdateResponseDataUserAddressStreetAddress1Max = 255;
export const accountUsersUpdateResponseDataUserAddressStreetAddress2Max = 255;
export const accountUsersUpdateResponseDataUserAddressCityMax = 255;
export const accountUsersUpdateResponseDataUserAddressZipCodeMax = 20;
export const accountUsersUpdateResponseDataUserAddressStateMax = 255;
export const accountUsersUpdateResponseDataUserAddressCountryMax = 255;
export const accountUsersUpdateResponseDataUserPermissionsItemNameMax = 255;


export const accountUsersUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "user": zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountUsersUpdateResponseDataUserUsernameMax),
  "first_name": zod.string().max(accountUsersUpdateResponseDataUserFirstNameMax).nullable(),
  "last_name": zod.string().max(accountUsersUpdateResponseDataUserLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountUsersUpdateResponseDataUserEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountUsersUpdateResponseDataUserIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersUpdateResponseDataUserAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersUpdateResponseDataUserAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersUpdateResponseDataUserAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersUpdateResponseDataUserAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersUpdateResponseDataUserAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersUpdateResponseDataUserAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountUsersUpdateResponseDataUserPermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})
})
})


/**
 * Partially update specific fields(excluding username and password) of a user. Only provided fields will be updated.
 */
export const accountUsersPartialUpdateBodyFirstNameMax = 150;
export const accountUsersPartialUpdateBodyLastNameMax = 150;
export const accountUsersPartialUpdateBodyEmailMax = 254;
export const accountUsersPartialUpdateBodyAddressStreetAddress1Max = 255;
export const accountUsersPartialUpdateBodyAddressStreetAddress2Max = 255;
export const accountUsersPartialUpdateBodyAddressCityMax = 255;
export const accountUsersPartialUpdateBodyAddressZipCodeMax = 20;
export const accountUsersPartialUpdateBodyAddressStateMax = 255;
export const accountUsersPartialUpdateBodyAddressCountryMax = 255;


export const accountUsersPartialUpdateBody = zod.object({
  "first_name": zod.string().max(accountUsersPartialUpdateBodyFirstNameMax).optional(),
  "last_name": zod.string().max(accountUsersPartialUpdateBodyLastNameMax).optional(),
  "email": zod.email().min(1).max(accountUsersPartialUpdateBodyEmailMax).optional(),
  "preferred_language": zod.enum(['en', 'es']).optional(),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']).optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersPartialUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersPartialUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersPartialUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersPartialUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersPartialUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersPartialUpdateBodyAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()).optional(),
  "last_selected_org": zod.number().nullish()
})

export const accountUsersPartialUpdateResponseDataUserUsernameMax = 50;
export const accountUsersPartialUpdateResponseDataUserFirstNameMax = 150;
export const accountUsersPartialUpdateResponseDataUserLastNameMax = 150;
export const accountUsersPartialUpdateResponseDataUserEmailMax = 254;
export const accountUsersPartialUpdateResponseDataUserIdpIdMax = 255;
export const accountUsersPartialUpdateResponseDataUserAddressStreetAddress1Max = 255;
export const accountUsersPartialUpdateResponseDataUserAddressStreetAddress2Max = 255;
export const accountUsersPartialUpdateResponseDataUserAddressCityMax = 255;
export const accountUsersPartialUpdateResponseDataUserAddressZipCodeMax = 20;
export const accountUsersPartialUpdateResponseDataUserAddressStateMax = 255;
export const accountUsersPartialUpdateResponseDataUserAddressCountryMax = 255;
export const accountUsersPartialUpdateResponseDataUserPermissionsItemNameMax = 255;


export const accountUsersPartialUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "user": zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountUsersPartialUpdateResponseDataUserUsernameMax),
  "first_name": zod.string().max(accountUsersPartialUpdateResponseDataUserFirstNameMax).nullable(),
  "last_name": zod.string().max(accountUsersPartialUpdateResponseDataUserLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountUsersPartialUpdateResponseDataUserEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountUsersPartialUpdateResponseDataUserIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountUsersPartialUpdateResponseDataUserAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountUsersPartialUpdateResponseDataUserAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountUsersPartialUpdateResponseDataUserAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountUsersPartialUpdateResponseDataUserAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountUsersPartialUpdateResponseDataUserAddressStateMax).nullish(),
  "country": zod.string().max(accountUsersPartialUpdateResponseDataUserAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountUsersPartialUpdateResponseDataUserPermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})
})
})


/**
 * Change the password for a specific user. Requires current password verification and new password confirmation.
 */
export const accountUsersChangePasswordBody = zod.object({
  "old_password": zod.string().min(1),
  "password": zod.string().min(1)
})

export const accountUsersChangePasswordResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "message": zod.string().min(1)
})
})


/**
 * Remove a specific organization from a user's list of organizations. Requires the organization ID in the request body.
 */
export const accountUsersRemoveOrganizationBody = zod.object({
  "org_id": zod.number().describe('Organization ID to remove')
})

export const accountUsersRemoveOrganizationResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "message": zod.string().min(1)
})
})


/**
 * Validate if the current user's session is still active.
 */
export const accountValidateSessionListResponseDataUserUsernameMax = 50;
export const accountValidateSessionListResponseDataUserFirstNameMax = 150;
export const accountValidateSessionListResponseDataUserLastNameMax = 150;
export const accountValidateSessionListResponseDataUserEmailMax = 254;
export const accountValidateSessionListResponseDataUserIdpIdMax = 255;
export const accountValidateSessionListResponseDataUserAddressStreetAddress1Max = 255;
export const accountValidateSessionListResponseDataUserAddressStreetAddress2Max = 255;
export const accountValidateSessionListResponseDataUserAddressCityMax = 255;
export const accountValidateSessionListResponseDataUserAddressZipCodeMax = 20;
export const accountValidateSessionListResponseDataUserAddressStateMax = 255;
export const accountValidateSessionListResponseDataUserAddressCountryMax = 255;
export const accountValidateSessionListResponseDataUserPermissionsItemNameMax = 255;


export const accountValidateSessionListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "user": zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(accountValidateSessionListResponseDataUserUsernameMax),
  "first_name": zod.string().max(accountValidateSessionListResponseDataUserFirstNameMax).nullable(),
  "last_name": zod.string().max(accountValidateSessionListResponseDataUserLastNameMax).nullable(),
  "email": zod.email().min(1).max(accountValidateSessionListResponseDataUserEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(accountValidateSessionListResponseDataUserIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(accountValidateSessionListResponseDataUserAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(accountValidateSessionListResponseDataUserAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(accountValidateSessionListResponseDataUserAddressCityMax).nullish(),
  "zip_code": zod.string().max(accountValidateSessionListResponseDataUserAddressZipCodeMax).nullish(),
  "state": zod.string().max(accountValidateSessionListResponseDataUserAddressStateMax).nullish(),
  "country": zod.string().max(accountValidateSessionListResponseDataUserAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(accountValidateSessionListResponseDataUserPermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
})
})
})


/**
 * Verify a user's email using a token sent via email.
 */
export const accountVerifyCreateParams = zod.object({
  "token": zod.uuid().describe('Verification token (UUID4)')
})

export const accountVerifyCreateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "success": zod.boolean()
})
})


/**
 * Retrieve all image IDs and GPS coordinates for a specific mission.
 * @summary Get Mission Image Metadata
 */
export const agricamImagesMetaDataReadParams = zod.object({
  "mission_id": zod.string().describe('ID of the mission to retrieve image metadata for')
})


/**
 * Upload and save an image along with its metadata.
 * @summary Save Image
 */
export const agricamImagesUploadCreateBody = zod.object({
  "image_file": zod.instanceof(File).describe('The image file to upload'),
  "metadata": zod.object({

}).describe('Metadata associated with the image'),
  "device_uuid": zod.string().describe('UUID of the device to associate the image with')
})


/**
 * Fetch the JPEG data and metadata for the specified image ID.
 * @summary Retrieve Image Data
 */
export const agricamImagesReadParams = zod.object({
  "image_id": zod.string().describe('UUID of the image to retrieve')
})

export const agricamImagesReadResponse = zod.object({
  "id": zod.uuid().optional(),
  "metadata": zod.string().optional(),
  "image_file": zod.url().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "campaign": zod.uuid().nullish()
})


/**
 * ViewSet for managing Agricam missions.
 */
export const agricamMissionsListResponseNameMax = 200;


export const agricamMissionsListResponseItem = zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).max(agricamMissionsListResponseNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish(),
  "campaign": zod.uuid().nullish()
})
export const agricamMissionsListResponse = zod.array(agricamMissionsListResponseItem)


/**
 * This API allows you to create a new mission for 'Agricam' and associates it with the 'SiFly' organization. The created mission is linked to the active campaign, if one exists, or the most recently created campaign if no active campaign is found.
 * @summary Create Agricam Mission
 */
export const agricamMissionsCreateBody = zod.object({
  "name": zod.string().describe('name of the mission'),
  "created_by": zod.string().describe('user who created the mission'),
  "status": zod.string().describe('status of the mission')
})


/**
 * ViewSet for managing Agricam missions.
 */
export const agricamMissionsReadResponseNameMax = 200;


export const agricamMissionsReadResponse = zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).max(agricamMissionsReadResponseNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish(),
  "campaign": zod.uuid().nullish()
})


/**
 * ViewSet for managing Agricam missions.
 */
export const agricamMissionsUpdateBodyNameMax = 200;


export const agricamMissionsUpdateBody = zod.object({
  "name": zod.string().min(1).max(agricamMissionsUpdateBodyNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish(),
  "campaign": zod.uuid().nullish()
})

export const agricamMissionsUpdateResponseNameMax = 200;


export const agricamMissionsUpdateResponse = zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).max(agricamMissionsUpdateResponseNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish(),
  "campaign": zod.uuid().nullish()
})


/**
 * @summary List campaigns across user's organizations (optionally filter by device's organization)
 */
export const crewCampaignsListQueryParams = zod.object({
  "status": zod.union([zod.literal(0),zod.literal(1)]).optional().describe('Filter campaigns by status. 1=Active, 0=Inactive'),
  "device_uuid": zod.uuid().optional().describe('If provided, list only campaigns in the organization that owns this device (must also be an org the user belongs to).')
})

export const crewCampaignsListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).optional(),
  "status": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "organization_name": zod.string().min(1).optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "start_time": zod.iso.datetime({}).optional(),
  "end_time": zod.iso.datetime({}).optional(),
  "landing_url": zod.string().optional(),
  "has_active_session": zod.boolean().optional()
}))
})


export const crewCampaignsCreateBody = zod.object({

})


/**
 * HTTP 302 redirect to active session landing URL.
This endpoint replaces the standard retrieve endpoint.
Public endpoint - no authentication required for redirect.
 * @summary HTTP redirect to active session landing URL (public endpoint)
 */
export const crewCampaignsSessionRedirectParams = zod.object({
  "pk": zod.uuid().describe('Campaign ID (UUID)')
})

export const crewCampaignsSessionRedirectResponse = zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).optional(),
  "status": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "organization_name": zod.string().min(1).optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "start_time": zod.iso.datetime({}).optional(),
  "end_time": zod.iso.datetime({}).optional(),
  "landing_url": zod.string().optional(),
  "has_active_session": zod.boolean().optional()
})


/**
 * @summary Get active session for a campaign
 */
export const crewCampaignsGetSessionParams = zod.object({
  "pk": zod.uuid().describe('Campaign ID (UUID)')
})

export const crewCampaignsGetSessionResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "last_ping_at": zod.iso.datetime({}).nullish(),
  "viewer_count": zod.number().optional(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "crew_base_url": zod.string().optional(),
  "landing_url": zod.string().optional(),
  "video_url": zod.string().optional()
})
})


/**
 * @summary List shared sessions (status=enabled by default)
 */
export const crewSharedSessionsListQueryParams = zod.object({
  "status": zod.enum(['enabled', 'disabled', 'all']).optional().describe('Filter sessions by status. Defaults to \'enabled\'.'),
  "ordering": zod.string().optional().describe('Ordering field (default: -created_at). Examples: -created_at, created_at'),
  "device_uuid": zod.uuid().optional().describe('Filter by device UUID')
})

export const crewSharedSessionsListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).optional(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "device_name": zod.string().min(1).optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
}))
})


/**
 * @summary Create a shared session (owner = request.user)
 */
export const crewSharedSessionsCreateBody = zod.object({
  "device_uuid": zod.uuid().describe('Device UUID (unique per device).'),
  "campaign_id": zod.uuid().nullish().describe('Campaign ID (optional).'),
  "name": zod.string().min(1).nullish().describe('Optional name for the shared session.')
})


/**
 * @summary List shared sessions by organization (status=enabled by default)
 */
export const crewSharedSessionsByOrganizationParams = zod.object({
  "organization_id": zod.number().describe('Organization ID (integer)')
})

export const crewSharedSessionsByOrganizationQueryParams = zod.object({
  "status": zod.enum(['enabled', 'disabled', 'all']).optional().describe('Filter sessions by status. Defaults to \'enabled\'.'),
  "ordering": zod.string().optional().describe('Ordering field (default: -created_at). Examples: -created_at, created_at'),
  "device_uuid": zod.uuid().optional().describe('Filter by device UUID')
})

export const crewSharedSessionsByOrganizationResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).optional(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "device_name": zod.string().min(1).optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
}))
})


/**
 * @summary Get a shared session
 */
export const crewSharedSessionsRetrieveParams = zod.object({
  "pk": zod.uuid().describe('Shared session ID (UUID)')
})

export const crewSharedSessionsRetrieveResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "last_ping_at": zod.iso.datetime({}).nullish(),
  "viewer_count": zod.number().optional(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "crew_base_url": zod.string().optional(),
  "landing_url": zod.string().optional(),
  "video_url": zod.string().optional()
})
})


/**
 * @summary Enable a shared session (actor = request.user)
 */
export const crewSharedSessionsEnableParams = zod.object({
  "pk": zod.uuid().describe('Shared session ID (UUID)')
})

export const crewSharedSessionsEnableBody = zod.object({

})

export const crewSharedSessionsEnableResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "last_ping_at": zod.iso.datetime({}).nullish(),
  "viewer_count": zod.number().optional(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "crew_base_url": zod.string().optional(),
  "landing_url": zod.string().optional(),
  "video_url": zod.string().optional()
})
})


/**
 * @summary Ping a shared session (owner-only) to keep it alive
 */
export const crewSharedSessionsPingParams = zod.object({
  "pk": zod.uuid().describe('Shared session ID (UUID)')
})

export const crewSharedSessionsPingBody = zod.object({

})

export const crewSharedSessionsPingResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "last_ping_at": zod.iso.datetime({}).nullish(),
  "viewer_count": zod.number().optional(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "crew_base_url": zod.string().optional(),
  "landing_url": zod.string().optional(),
  "video_url": zod.string().optional()
})
})


/**
 * @summary Stop a shared session (actor = request.user)
 */
export const crewSharedSessionsStopParams = zod.object({
  "pk": zod.uuid().describe('Shared session ID (UUID)')
})

export const crewSharedSessionsStopBody = zod.object({

})

export const crewSharedSessionsStopResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "enabled": zod.boolean().optional(),
  "device_uuid": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "organization_id": zod.number().optional(),
  "campaign_id": zod.uuid().nullish(),
  "campaign_name": zod.string().min(1).nullish(),
  "last_ping_at": zod.iso.datetime({}).nullish(),
  "viewer_count": zod.number().optional(),
  "created_by": zod.number().optional(),
  "updated_by": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "crew_base_url": zod.string().optional(),
  "landing_url": zod.string().optional(),
  "video_url": zod.string().optional()
})
})


/**
 * Dispatches an ATC command for the authenticated participant. Use `command=start` with optional `device_uuids` in the request body, or `command=end` with an empty body.
 * @summary Dispatch an ATC command for a shared session
 */
export const crewAtcCommandDispatchParams = zod.object({
  "shared_session_id": zod.uuid().describe('Shared session ID (UUID)'),
  "command": zod.enum(['start', 'end']).describe('ATC command name')
})

export const crewAtcCommandDispatchBody = zod.object({
  "device_uuids": zod.array(zod.uuid()).nullish().describe('Optional list of device UUIDs to include in the ATC start-turn dispatch. If omitted, null, or empty, the server may fall back to CREW_ATC_DEMO_DEVICES.')
})

export const crewAtcCommandDispatchResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "session_id": zod.uuid(),
  "participant_id": zod.uuid(),
  "agent_identity": zod.string().min(1),
  "rpc_topic": zod.string().min(1),
  "agent_response": zod.string(),
  "dispatched_drones": zod.array(zod.uuid())
})
})


/**
 * @summary List participants in a shared session
 */
export const crewSharedSessionsParticipantsListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "shared_session_id": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "anon_id": zod.uuid().nullish(),
  "display_name": zod.string().min(1).nullish(),
  "is_authenticated": zod.boolean().optional(),
  "is_online": zod.boolean().optional(),
  "first_seen": zod.iso.datetime({}).optional(),
  "last_seen": zod.iso.datetime({}).optional(),
  "join_count": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
}))
})


/**
 * @summary Register anonymous participant (write-once display_name)
 */
export const crewSharedSessionsParticipantsRegisterAnonymousBodyDisplayNameMax = 64;


export const crewSharedSessionsParticipantsRegisterAnonymousBody = zod.object({
  "display_name": zod.string().max(crewSharedSessionsParticipantsRegisterAnonymousBodyDisplayNameMax).nullish().describe('Optional display name (write-once). If omitted, server auto-generates.')
})


/**
 * @summary Register authenticated participant (idempotent)
 */
export const crewSharedSessionsParticipantsRegisterAuthBody = zod.object({

})

export const crewSharedSessionsParticipantsRegisterAuthResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "shared_session_id": zod.uuid().optional(),
  "user_id": zod.number().optional(),
  "anon_id": zod.uuid().nullish(),
  "display_name": zod.string().min(1).nullish(),
  "is_authenticated": zod.boolean().optional(),
  "is_online": zod.boolean().optional(),
  "first_seen": zod.iso.datetime({}).optional(),
  "last_seen": zod.iso.datetime({}).optional(),
  "join_count": zod.number().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})
})


/**
 * GET historic telemetry for a session/participant/device.
Anonymous allowed; we authorize via session/participant checks in the service.
 * @summary Historic telemetry (with optional downsampling)
 */
export const crewSharedSessionsParticipantsDeviceTelemetryListParams = zod.object({
  "shared_session_id": zod.uuid().describe('Shared session ID'),
  "participant_id": zod.uuid().describe('Participant ID (auth or anon)'),
  "device_uuid": zod.uuid().describe('Device UUID')
})

export const crewSharedSessionsParticipantsDeviceTelemetryListQueryLimitDefault = 500;export const crewSharedSessionsParticipantsDeviceTelemetryListQueryOffsetDefault = 0;
export const crewSharedSessionsParticipantsDeviceTelemetryListQueryOffsetMin = 0;


export const crewSharedSessionsParticipantsDeviceTelemetryListQueryParams = zod.object({
  "start": zod.iso.datetime({}).optional().describe('ISO-8601 with timezone (e.g. 2025-10-21T12:00:00Z). Default: earliest telemetry for device.'),
  "end": zod.iso.datetime({}).optional().describe('ISO-8601 with timezone. Default: now (UTC).'),
  "resolution": zod.number().min(1).optional().describe('Downsample window in seconds (optional). If absent, returns raw points.'),
  "limit": zod.number().min(1).default(crewSharedSessionsParticipantsDeviceTelemetryListQueryLimitDefault),
  "offset": zod.number().min(crewSharedSessionsParticipantsDeviceTelemetryListQueryOffsetMin).optional()
})

export const crewSharedSessionsParticipantsDeviceTelemetryListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "results": zod.array(zod.object({
  "timestamp": zod.iso.datetime({}),
  "latitude": zod.string().min(1).nullable(),
  "longitude": zod.string().min(1).nullable(),
  "absolute_altitude": zod.string().min(1).nullable(),
  "remaining_percent": zod.string().min(1).nullable(),
  "duration_since_takeoff_ms": zod.string().min(1).nullable(),
  "raw_json": zod.object({

})
})),
  "count": zod.number(),
  "next": zod.url().min(1).nullish(),
  "previous": zod.url().min(1).nullish()
})
})


/**
 * Generate access token and connection information for joining a voice chat room. This endpoint replaces the WebSocket-based voice chat connection. The frontend should use the returned credentials to connect directly to the voice chat provider (e.g., LiveKit SDK).
 * @summary Generate voice chat credentials
 */
export const crewSharedSessionsParticipantsVoiceChatCredentialsCreateBody = zod.object({

})

export const crewSharedSessionsParticipantsVoiceChatCredentialsCreateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "token": zod.string().min(1).describe('Access token for joining the voice chat room'),
  "url": zod.string().min(1).describe('Voice chat provider server URL'),
  "room_name": zod.string().min(1).describe('Room name to join'),
  "session_id": zod.uuid().describe('Shared session ID'),
  "participant_id": zod.uuid().describe('Participant ID'),
  "provider": zod.string().min(1).describe('Voice chat provider type (e.g., \'livekit\')')
})
})


/**
 * Fetches terrain elevation data from Auterion's terrain API. Responses are cached based on query parameters to reduce redundant requests. This endpoint bypasses CORS restrictions.
 * @summary Get terrain carpet data (CORS proxy with caching)
 */
export const crewTerrainCarpetListQueryParams = zod.object({
  "points": zod.string().describe('Comma-separated coordinates defining the bounding box. Format: \'lat1,lon1,lat2,lon2\' (e.g., \'37.78,-122.45,37.79,-122.44\')')
})

export const crewTerrainCarpetListResponse = zod.object({
  "status": zod.string().optional(),
  "data": zod.object({
  "bounds": zod.object({
  "ne": zod.array(zod.number()).optional(),
  "sw": zod.array(zod.number()).optional()
}).optional(),
  "carpet": zod.array(zod.array(zod.number())).optional().describe('2D array of elevation values'),
  "stats": zod.object({
  "avg": zod.number().optional(),
  "max": zod.number().optional(),
  "min": zod.number().optional()
}).optional()
}).optional()
})


/**
 * Generate access token and connection information for joining a voice chat room using email. This endpoint looks up the user by email, finds the user's enabled session, gets or creates a participant for the user, and updates last_seen. This endpoint does not require CSRF token. The frontend should use the returned credentials to connect directly to the voice chat provider (e.g., LiveKit SDK).
 * @summary Join voice chat room with user info
 */
export const crewVoiceChatJoinCreateBody = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "email": zod.email().min(1).describe('User email address')
})
})

export const crewVoiceChatJoinCreateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "token": zod.string().min(1).describe('Access token for joining the voice chat room'),
  "url": zod.string().min(1).describe('Voice chat provider server URL'),
  "room_name": zod.string().min(1).describe('Room name to join'),
  "session_id": zod.uuid().describe('Shared session ID'),
  "participant_id": zod.uuid().describe('Participant ID'),
  "provider": zod.string().min(1).describe('Voice chat provider type (e.g., \'livekit\')')
})
})


export const droneCommanderCampaignsListResponseNameMax = 255;


export const droneCommanderCampaignsListResponseItem = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(droneCommanderCampaignsListResponseNameMax),
  "description": zod.string().min(1),
  "users": zod.array(zod.number()),
  "status": zod.union([zod.literal(0),zod.literal(1)]),
  "organization": zod.number().nullable(),
  "start_time": zod.iso.datetime({}).nullable(),
  "end_time": zod.iso.datetime({}).nullable(),
  "created_by": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "device_details": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).nullish(),
  "device_uuid": zod.uuid()
})).optional(),
  "chats": zod.array(zod.number().nullable()),
  "preflight_checks": zod.array(zod.uuid()),
  "postflight_checks": zod.array(zod.uuid()),
  "enable_vantis_send": zod.boolean(),
  "missions": zod.array(zod.string()).optional(),
  "devices": zod.array(zod.uuid().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')).optional().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')
})
export const droneCommanderCampaignsListResponse = zod.array(droneCommanderCampaignsListResponseItem)


/**
 * Create a new campaign in the system. Requires valid campaign data including name, description, organization, drones, and status.
 */
export const droneCommanderCampaignsCreateBodyNameMax = 255;


export const droneCommanderCampaignsCreateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderCampaignsCreateBodyNameMax),
  "description": zod.string().nullable(),
  "status": zod.union([zod.literal(0),zod.literal(1)]),
  "organization": zod.number().nullable(),
  "devices": zod.array(zod.uuid().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')).optional().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.'),
  "enable_vantis_send": zod.boolean()
})


/**
 * Add a verified user to a specific campaign.
 * @summary Add a User to a Campaign
 */
export const droneCommanderCampaignsAddUsersBody = zod.object({
  "campaign_id": zod.uuid()
})


/**
 * Retrieve a list of all campaigns for a specific organization.
 */
export const droneCommanderCampaignsOrgReadResponseDataCampaignsItemNameMax = 255;


export const droneCommanderCampaignsOrgReadResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "campaigns": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(droneCommanderCampaignsOrgReadResponseDataCampaignsItemNameMax),
  "description": zod.string().min(1),
  "users": zod.array(zod.number()),
  "status": zod.union([zod.literal(0),zod.literal(1)]),
  "organization": zod.number().nullable(),
  "start_time": zod.iso.datetime({}).nullable(),
  "end_time": zod.iso.datetime({}).nullable(),
  "created_by": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "device_details": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).nullish(),
  "device_uuid": zod.uuid()
})).optional(),
  "chats": zod.array(zod.number().nullable()),
  "preflight_checks": zod.array(zod.uuid()),
  "postflight_checks": zod.array(zod.uuid()),
  "enable_vantis_send": zod.boolean(),
  "missions": zod.array(zod.string()).optional(),
  "devices": zod.array(zod.uuid().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')).optional().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')
}))
})
})


/**
 * Remove a verified user from a specific campaign.
 * @summary Remove a User from a Campaign
 */
export const droneCommanderCampaignsRemoveUsersBody = zod.object({
  "campaign_id": zod.uuid()
})


export const droneCommanderCampaignsReadResponseNameMax = 255;


export const droneCommanderCampaignsReadResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(droneCommanderCampaignsReadResponseNameMax),
  "description": zod.string().min(1),
  "users": zod.array(zod.number()),
  "status": zod.union([zod.literal(0),zod.literal(1)]),
  "organization": zod.number().nullable(),
  "start_time": zod.iso.datetime({}).nullable(),
  "end_time": zod.iso.datetime({}).nullable(),
  "created_by": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "device_details": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).nullish(),
  "device_uuid": zod.uuid()
})).optional(),
  "chats": zod.array(zod.number().nullable()),
  "preflight_checks": zod.array(zod.uuid()),
  "postflight_checks": zod.array(zod.uuid()),
  "enable_vantis_send": zod.boolean(),
  "missions": zod.array(zod.string()).optional(),
  "devices": zod.array(zod.uuid().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')).optional().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')
})


export const droneCommanderCampaignsUpdateBody = zod.object({

})

export const droneCommanderCampaignsUpdateResponse = zod.object({

})


/**
 * Update status and enable_dronesense fields of a campaign.
 */
export const droneCommanderCampaignsPartialUpdateBody = zod.object({

})

export const droneCommanderCampaignsPartialUpdateResponseDataCampaignNameMax = 255;


export const droneCommanderCampaignsPartialUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "campaign": zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(droneCommanderCampaignsPartialUpdateResponseDataCampaignNameMax),
  "description": zod.string().min(1),
  "users": zod.array(zod.number()),
  "status": zod.union([zod.literal(0),zod.literal(1)]),
  "organization": zod.number().nullable(),
  "start_time": zod.iso.datetime({}).nullable(),
  "end_time": zod.iso.datetime({}).nullable(),
  "created_by": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "device_details": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).nullish(),
  "device_uuid": zod.uuid()
})).optional(),
  "chats": zod.array(zod.number().nullable()),
  "preflight_checks": zod.array(zod.uuid()),
  "postflight_checks": zod.array(zod.uuid()),
  "enable_vantis_send": zod.boolean(),
  "missions": zod.array(zod.string()).optional(),
  "devices": zod.array(zod.uuid().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')).optional().describe('Devices associated with the campaign (preferred). Provide a list of device_uuid strings.')
})
})
})


/**
 * Retrieve all users associated with a campaign and the current controller.
 * @summary Get Users in Campaign
 */
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemUsernameMax = 50;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemFirstNameMax = 150;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemLastNameMax = 150;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemEmailMax = 254;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemIdpIdMax = 255;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressStreetAddress1Max = 255;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressStreetAddress2Max = 255;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressCityMax = 255;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressZipCodeMax = 20;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressStateMax = 255;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressCountryMax = 255;
export const droneCommanderCampaignsGetCampaignUsersResponseUsersItemPermissionsItemNameMax = 255;


export const droneCommanderCampaignsGetCampaignUsersResponse = zod.object({
  "users": zod.array(zod.object({
  "id": zod.number(),
  "username": zod.string().min(1).max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemUsernameMax),
  "first_name": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemFirstNameMax).nullable(),
  "last_name": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemLastNameMax).nullable(),
  "email": zod.email().min(1).max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemEmailMax),
  "is_verified": zod.boolean().optional(),
  "is_active": zod.boolean().optional(),
  "idp_id": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemIdpIdMax).nullish(),
  "preferred_language": zod.enum(['en', 'es']),
  "color_scheme_preference": zod.enum(['default', 'light', 'dark']),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemAddressCountryMax).nullish()
}).optional(),
  "organizations": zod.array(zod.number()),
  "last_selected_org": zod.number().nullable(),
  "avatar": zod.url().nullish(),
  "initials": zod.string().optional(),
  "permissions": zod.array(zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(droneCommanderCampaignsGetCampaignUsersResponseUsersItemPermissionsItemNameMax),
  "description": zod.string().min(1)
})).optional(),
  "assignable_roles": zod.array(zod.object({

})).optional()
}))
})


/**
 * Retrieve detailed information about a specific device using the device_uuid field. User must have permission to access the device (belong to the device's organization or be a superuser).
 * @summary Get device details by device UUID
 */
export const droneCommanderDeviceDetailsParams = zod.object({
  "device_id": zod.uuid().describe('Device UUID (not the primary key ID)')
})

export const droneCommanderDeviceDetailsResponseDataNameMax = 100;
export const droneCommanderDeviceDetailsResponseDataDeviceTypeNameMax = 100;
export const droneCommanderDeviceDetailsResponseDataDeviceTypeModelNameMax = 100;
export const droneCommanderDeviceDetailsResponseDataDeviceTypeModelNumberMax = 100;
export const droneCommanderDeviceDetailsResponseDataDeviceTypeHardwareIdMax = 100;
export const droneCommanderDeviceDetailsResponseDataSerialNumberMax = 15;
export const droneCommanderDeviceDetailsResponseDataRemoteIdNumberMax = 20;
export const droneCommanderDeviceDetailsResponseDataFaaRegNumberMax = 10;


export const droneCommanderDeviceDetailsResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().max(droneCommanderDeviceDetailsResponseDataNameMax).nullish(),
  "device_type": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).max(droneCommanderDeviceDetailsResponseDataDeviceTypeNameMax),
  "description": zod.string().optional(),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "manufacturer_name": zod.string().min(1).optional(),
  "model_name": zod.string().max(droneCommanderDeviceDetailsResponseDataDeviceTypeModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDeviceDetailsResponseDataDeviceTypeModelNumberMax).optional(),
  "hardware_id": zod.string().max(droneCommanderDeviceDetailsResponseDataDeviceTypeHardwareIdMax).nullish(),
  "thumbnail": zod.string().optional(),
  "images": zod.string().optional()
}).optional(),
  "description": zod.string().optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).max(droneCommanderDeviceDetailsResponseDataSerialNumberMax),
  "remote_id_number": zod.string().max(droneCommanderDeviceDetailsResponseDataRemoteIdNumberMax).nullish(),
  "faa_reg_number": zod.string().max(droneCommanderDeviceDetailsResponseDataFaaRegNumberMax).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "release_date": zod.iso.date().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "device_uuid": zod.uuid(),
  "setting_specifications": zod.array(zod.object({
  "id": zod.number().optional(),
  "setting_type_name": zod.string().min(1).optional(),
  "setting_type_type": zod.string().min(1).optional(),
  "string_value": zod.string().nullish(),
  "number_value": zod.string().nullish(),
  "boolean_value": zod.boolean().nullish(),
  "date_value": zod.iso.date().nullish()
})).optional(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})
})


/**
 * Retrieve a list of all device types in the system. This endpoint is accessible to all authenticated users.
 * @summary List device types
 */
export const droneCommanderDeviceTypesListResponse = zod.object({
  "status": zod.number().optional(),
  "message": zod.string().optional(),
  "data": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional(),
  "model_name": zod.string().optional(),
  "model_number": zod.string().optional(),
  "category": zod.string().optional(),
  "manufacturer": zod.uuid().optional(),
  "hardware_id": zod.string().optional(),
  "image": zod.url().optional(),
  "thumbnail": zod.url().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})).optional()
})


/**
 * Create a new device type. Requires 'view_create_device_types' permission.
 * @summary Create device type
 */
export const droneCommanderDeviceTypesCreateBodyNameMax = 100;
export const droneCommanderDeviceTypesCreateBodyModelNameMax = 100;
export const droneCommanderDeviceTypesCreateBodyModelNumberMax = 100;
export const droneCommanderDeviceTypesCreateBodyHardwareIdMax = 100;


export const droneCommanderDeviceTypesCreateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderDeviceTypesCreateBodyNameMax),
  "description": zod.string().optional(),
  "model_name": zod.string().max(droneCommanderDeviceTypesCreateBodyModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDeviceTypesCreateBodyModelNumberMax),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "hardware_id": zod.string().max(droneCommanderDeviceTypesCreateBodyHardwareIdMax).nullish(),
  "manufacturer": zod.number().nullish()
})


/**
 * Retrieve a specific device type by its ID. Requires 'view_retrieve_device_types' permission.
 * @summary Get device type by ID
 */
export const droneCommanderDeviceTypesReadParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) of the device type')
})

export const droneCommanderDeviceTypesReadResponse = zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional(),
  "model_name": zod.string().optional(),
  "model_number": zod.string().optional(),
  "category": zod.string().optional(),
  "manufacturer": zod.uuid().optional(),
  "hardware_id": zod.string().optional(),
  "image": zod.url().optional(),
  "thumbnail": zod.url().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


/**
 * Update an existing device type. Requires 'view_update_device_types' permission.
 * @summary Update device type
 */
export const droneCommanderDeviceTypesUpdateParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) of the device type')
})

export const droneCommanderDeviceTypesUpdateBodyNameMax = 100;
export const droneCommanderDeviceTypesUpdateBodyModelNameMax = 100;
export const droneCommanderDeviceTypesUpdateBodyModelNumberMax = 100;
export const droneCommanderDeviceTypesUpdateBodyHardwareIdMax = 100;


export const droneCommanderDeviceTypesUpdateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderDeviceTypesUpdateBodyNameMax),
  "description": zod.string().optional(),
  "model_name": zod.string().max(droneCommanderDeviceTypesUpdateBodyModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDeviceTypesUpdateBodyModelNumberMax),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "hardware_id": zod.string().max(droneCommanderDeviceTypesUpdateBodyHardwareIdMax).nullish(),
  "manufacturer": zod.number().nullish()
})

export const droneCommanderDeviceTypesUpdateResponseNameMax = 100;
export const droneCommanderDeviceTypesUpdateResponseModelNameMax = 100;
export const droneCommanderDeviceTypesUpdateResponseModelNumberMax = 100;
export const droneCommanderDeviceTypesUpdateResponseHardwareIdMax = 100;


export const droneCommanderDeviceTypesUpdateResponse = zod.object({
  "id": zod.uuid().optional(),
  "image": zod.url().nullish(),
  "thumbnail": zod.string().optional(),
  "images": zod.string().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(droneCommanderDeviceTypesUpdateResponseNameMax),
  "description": zod.string().optional(),
  "model_name": zod.string().max(droneCommanderDeviceTypesUpdateResponseModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDeviceTypesUpdateResponseModelNumberMax),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "hardware_id": zod.string().max(droneCommanderDeviceTypesUpdateResponseHardwareIdMax).nullish(),
  "manufacturer": zod.number().nullish()
})


/**
 * Partially update an existing device type. Requires 'view_update_device_types' permission.
 * @summary Partially update device type
 */
export const droneCommanderDeviceTypesPartialUpdateParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) of the device type')
})

export const droneCommanderDeviceTypesPartialUpdateBodyNameMax = 100;
export const droneCommanderDeviceTypesPartialUpdateBodyModelNameMax = 100;
export const droneCommanderDeviceTypesPartialUpdateBodyModelNumberMax = 100;
export const droneCommanderDeviceTypesPartialUpdateBodyHardwareIdMax = 100;


export const droneCommanderDeviceTypesPartialUpdateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderDeviceTypesPartialUpdateBodyNameMax),
  "description": zod.string().optional(),
  "model_name": zod.string().max(droneCommanderDeviceTypesPartialUpdateBodyModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDeviceTypesPartialUpdateBodyModelNumberMax),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "hardware_id": zod.string().max(droneCommanderDeviceTypesPartialUpdateBodyHardwareIdMax).nullish(),
  "manufacturer": zod.number().nullish()
})

export const droneCommanderDeviceTypesPartialUpdateResponseNameMax = 100;
export const droneCommanderDeviceTypesPartialUpdateResponseModelNameMax = 100;
export const droneCommanderDeviceTypesPartialUpdateResponseModelNumberMax = 100;
export const droneCommanderDeviceTypesPartialUpdateResponseHardwareIdMax = 100;


export const droneCommanderDeviceTypesPartialUpdateResponse = zod.object({
  "id": zod.uuid().optional(),
  "image": zod.url().nullish(),
  "thumbnail": zod.string().optional(),
  "images": zod.string().optional(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "name": zod.string().min(1).max(droneCommanderDeviceTypesPartialUpdateResponseNameMax),
  "description": zod.string().optional(),
  "model_name": zod.string().max(droneCommanderDeviceTypesPartialUpdateResponseModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDeviceTypesPartialUpdateResponseModelNumberMax),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "hardware_id": zod.string().max(droneCommanderDeviceTypesPartialUpdateResponseHardwareIdMax).nullish(),
  "manufacturer": zod.number().nullish()
})


/**
 * Delete an existing device type. Requires 'view_delete_device_types' permission.
 * @summary Delete device type
 */
export const droneCommanderDeviceTypesDeleteParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) of the device type')
})


/**
 * Retrieve a list of all devices. Requires 'view_all_devices' permission. If user doesn't have permission, returns 403 Forbidden.
 * @summary List all devices
 */
export const droneCommanderDevicesListQueryLimitDefault = 20;
export const droneCommanderDevicesListQueryLimitMax = 100;
export const droneCommanderDevicesListQueryOffsetDefault = 0;
export const droneCommanderDevicesListQueryOffsetMin = 0;
export const droneCommanderDevicesListQueryOrderingDefault = "-created_at";

export const droneCommanderDevicesListQueryParams = zod.object({
  "limit": zod.number().min(1).max(droneCommanderDevicesListQueryLimitMax).default(droneCommanderDevicesListQueryLimitDefault),
  "offset": zod.number().min(droneCommanderDevicesListQueryOffsetMin).optional(),
  "search": zod.string().min(1).optional(),
  "ordering": zod.string().min(1).default(droneCommanderDevicesListQueryOrderingDefault),
  "device_type": zod.uuid().optional(),
  "is_active": zod.boolean().optional().describe('Filter by active status (true/false)')
})

export const droneCommanderDevicesListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "results": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "device_type": zod.string().optional(),
  "description": zod.string().min(1).optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).optional(),
  "device_uuid": zod.uuid().optional(),
  "faa_reg_number": zod.string().min(1).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "organization": zod.number().nullish(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})),
  "count": zod.number(),
  "next": zod.url().min(1).nullish(),
  "previous": zod.url().min(1).nullish()
})
})


/**
 * Create a new device. Requires 'manufacture' permission. If no organization is specified, the device will be created without an organization or assigned to the user's first organization.
 * @summary Create a new device
 */
export const droneCommanderDevicesCreateBodyNameMax = 100;
export const droneCommanderDevicesCreateBodySerialNumberMax = 15;
export const droneCommanderDevicesCreateBodyFaaRegNumberMax = 10;


export const droneCommanderDevicesCreateBody = zod.object({
  "name": zod.string().max(droneCommanderDevicesCreateBodyNameMax).nullish(),
  "device_type": zod.uuid(),
  "description": zod.string().optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).max(droneCommanderDevicesCreateBodySerialNumberMax),
  "device_uuid": zod.uuid(),
  "faa_reg_number": zod.string().max(droneCommanderDevicesCreateBodyFaaRegNumberMax).nullish(),
  "organization": zod.number().nullish()
})


/**
 * Retrieve a paginated list of all devices in the system. Requires 'manufacture' permission. This endpoint shows all devices regardless of organization.
 * @summary Get all devices
 */
export const droneCommanderDevicesAllDevicesQueryLimitDefault = 20;
export const droneCommanderDevicesAllDevicesQueryLimitMax = 100;
export const droneCommanderDevicesAllDevicesQueryOffsetDefault = 0;
export const droneCommanderDevicesAllDevicesQueryOffsetMin = 0;
export const droneCommanderDevicesAllDevicesQueryOrderingDefault = "-created_at";

export const droneCommanderDevicesAllDevicesQueryParams = zod.object({
  "limit": zod.number().min(1).max(droneCommanderDevicesAllDevicesQueryLimitMax).default(droneCommanderDevicesAllDevicesQueryLimitDefault),
  "offset": zod.number().min(droneCommanderDevicesAllDevicesQueryOffsetMin).optional(),
  "search": zod.string().min(1).optional(),
  "ordering": zod.string().min(1).default(droneCommanderDevicesAllDevicesQueryOrderingDefault),
  "device_type": zod.uuid().optional(),
  "is_active": zod.boolean().optional().describe('Filter by active status (true/false)')
})

export const droneCommanderDevicesAllDevicesResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "results": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "device_type": zod.string().optional(),
  "description": zod.string().min(1).optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).optional(),
  "device_uuid": zod.uuid().optional(),
  "faa_reg_number": zod.string().min(1).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "organization": zod.number().nullish(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})),
  "count": zod.number(),
  "next": zod.url().min(1).nullish(),
  "previous": zod.url().min(1).nullish()
})
})


/**
 * Check whether a device is registered using its device_uuid.
 * @summary Check device registration status
 */
export const droneCommanderDevicesCheckRegistrationQueryParams = zod.object({
  "device_uuid": zod.uuid().describe('Device UUID (device_uuid field)')
})

export const droneCommanderDevicesCheckRegistrationResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "device_uuid": zod.string().min(1),
  "is_registered": zod.boolean(),
  "organization": zod.string().min(1).nullable()
})
})


/**
 * Register a device by linking it to the user's organization. The device must exist in the system and have an active heartbeat, but not be already registered to an organization.
 * @summary Register a device
 */
export const droneCommanderDevicesRegisterBody = zod.object({
  "device_uuid": zod.uuid().describe('Device UUID to register')
})

export const droneCommanderDevicesRegisterResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid(),
  "device_uuid": zod.uuid(),
  "organization": zod.string().min(1).nullable()
})
})


/**
 * Retrieve a paginated list of devices that belong to the user's organization(s). Regular users can only see devices from their organizations, while superusers can see all devices. Now includes heartbeat data and device type details.
 * @summary Get registered devices
 */
export const droneCommanderDevicesRegisteredDevicesQueryLimitDefault = 20;
export const droneCommanderDevicesRegisteredDevicesQueryLimitMax = 100;
export const droneCommanderDevicesRegisteredDevicesQueryOffsetDefault = 0;
export const droneCommanderDevicesRegisteredDevicesQueryOffsetMin = 0;
export const droneCommanderDevicesRegisteredDevicesQueryOrderingDefault = "-created_at";

export const droneCommanderDevicesRegisteredDevicesQueryParams = zod.object({
  "limit": zod.number().min(1).max(droneCommanderDevicesRegisteredDevicesQueryLimitMax).default(droneCommanderDevicesRegisteredDevicesQueryLimitDefault),
  "offset": zod.number().min(droneCommanderDevicesRegisteredDevicesQueryOffsetMin).optional(),
  "search": zod.string().min(1).optional(),
  "ordering": zod.string().min(1).default(droneCommanderDevicesRegisteredDevicesQueryOrderingDefault),
  "device_type": zod.uuid().optional(),
  "is_active": zod.boolean().optional().describe('Filter by active status (true/false)')
})

export const droneCommanderDevicesRegisteredDevicesResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "results": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "device_type": zod.string().optional(),
  "description": zod.string().min(1).optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).optional(),
  "device_uuid": zod.uuid().optional(),
  "faa_reg_number": zod.string().min(1).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "organization": zod.number().nullish(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})),
  "count": zod.number(),
  "next": zod.url().min(1).nullish(),
  "previous": zod.url().min(1).nullish()
})
})


/**
 * Unregister a device by removing its organization link. The device must exist in the system and be currently registered to an organization that the user has access to.
 * @summary Unregister a device
 */
export const droneCommanderDevicesUnregisterBody = zod.object({
  "device_uuid": zod.uuid().describe('Device UUID to unregister')
})

export const droneCommanderDevicesUnregisterResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid(),
  "device_uuid": zod.uuid(),
  "organization": zod.string().min(1).nullable()
})
})


/**
 * Retrieve a device by its ID. User must have permission to access the device (belong to the device's organization or be a superuser). Returns detailed device information including device type, settings, and heartbeat data.
 * @summary Get device by ID
 */
export const droneCommanderDevicesReadParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) Primary Key of the device')
})

export const droneCommanderDevicesReadResponseDataNameMax = 100;
export const droneCommanderDevicesReadResponseDataDeviceTypeNameMax = 100;
export const droneCommanderDevicesReadResponseDataDeviceTypeModelNameMax = 100;
export const droneCommanderDevicesReadResponseDataDeviceTypeModelNumberMax = 100;
export const droneCommanderDevicesReadResponseDataDeviceTypeHardwareIdMax = 100;
export const droneCommanderDevicesReadResponseDataSerialNumberMax = 15;
export const droneCommanderDevicesReadResponseDataRemoteIdNumberMax = 20;
export const droneCommanderDevicesReadResponseDataFaaRegNumberMax = 10;


export const droneCommanderDevicesReadResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().max(droneCommanderDevicesReadResponseDataNameMax).nullish(),
  "device_type": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).max(droneCommanderDevicesReadResponseDataDeviceTypeNameMax),
  "description": zod.string().optional(),
  "category": zod.enum(['DRONE', 'SENSOR', 'CAMERA', 'CONTROLLER', 'STATION', 'OTHER']),
  "manufacturer_name": zod.string().min(1).optional(),
  "model_name": zod.string().max(droneCommanderDevicesReadResponseDataDeviceTypeModelNameMax).nullish(),
  "model_number": zod.string().max(droneCommanderDevicesReadResponseDataDeviceTypeModelNumberMax).optional(),
  "hardware_id": zod.string().max(droneCommanderDevicesReadResponseDataDeviceTypeHardwareIdMax).nullish(),
  "thumbnail": zod.string().optional(),
  "images": zod.string().optional()
}).optional(),
  "description": zod.string().optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).max(droneCommanderDevicesReadResponseDataSerialNumberMax),
  "remote_id_number": zod.string().max(droneCommanderDevicesReadResponseDataRemoteIdNumberMax).nullish(),
  "faa_reg_number": zod.string().max(droneCommanderDevicesReadResponseDataFaaRegNumberMax).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "release_date": zod.iso.date().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "device_uuid": zod.uuid(),
  "setting_specifications": zod.array(zod.object({
  "id": zod.number().optional(),
  "setting_type_name": zod.string().min(1).optional(),
  "setting_type_type": zod.string().min(1).optional(),
  "string_value": zod.string().nullish(),
  "number_value": zod.string().nullish(),
  "boolean_value": zod.boolean().nullish(),
  "date_value": zod.iso.date().nullish()
})).optional(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})
})


export const droneCommanderDevicesUpdateBody = zod.object({

})

export const droneCommanderDevicesUpdateResponse = zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "device_type": zod.string().optional(),
  "description": zod.string().min(1).optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).optional(),
  "device_uuid": zod.uuid().optional(),
  "faa_reg_number": zod.string().min(1).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "organization": zod.number().nullish(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})


/**
 * Partially update a device. User must have permission to access the device (belong to the device's organization or be a superuser).
 * @summary Update a device
 */
export const droneCommanderDevicesPartialUpdateParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) Primary Key of the device')
})

export const droneCommanderDevicesPartialUpdateBody = zod.object({
  "name": zod.string().min(1).optional().describe('Device name'),
  "description": zod.string().min(1).optional().describe('Device description'),
  "is_active": zod.boolean().optional().describe('Device active status'),
  "faa_reg_number": zod.string().min(1).optional().describe('FAA registration number')
})

export const droneCommanderDevicesPartialUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "name": zod.string().min(1).nullish(),
  "device_type": zod.string().optional(),
  "description": zod.string().min(1).optional(),
  "is_active": zod.boolean().optional(),
  "serial_number": zod.string().min(1).optional(),
  "device_uuid": zod.uuid().optional(),
  "faa_reg_number": zod.string().min(1).nullish(),
  "thumbnail": zod.url().nullish(),
  "image": zod.url().nullish(),
  "organization": zod.number().nullish(),
  "heart_beat": zod.string().optional(),
  "last_seen": zod.string().optional()
})
})


/**
 * Delete a device. User must have permission to access the device (belong to the device's organization or be a superuser).
 * @summary Delete a device
 */
export const droneCommanderDevicesDeleteParams = zod.object({
  "id": zod.uuid().describe('ID (UUID) Primary Key of the device')
})

export const droneCommanderDevicesDeleteResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "success": zod.boolean()
})
})


export const droneCommanderDroneModelsListResponseManufacturerMax = 255;
export const droneCommanderDroneModelsListResponseNameMax = 255;
export const droneCommanderDroneModelsListResponseTypeMax = 255;


export const droneCommanderDroneModelsListResponseItem = zod.object({
  "id": zod.number().optional(),
  "manufacturer": zod.string().max(droneCommanderDroneModelsListResponseManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsListResponseNameMax),
  "type": zod.string().max(droneCommanderDroneModelsListResponseTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})
export const droneCommanderDroneModelsListResponse = zod.array(droneCommanderDroneModelsListResponseItem)


export const droneCommanderDroneModelsCreateBodyManufacturerMax = 255;
export const droneCommanderDroneModelsCreateBodyNameMax = 255;
export const droneCommanderDroneModelsCreateBodyTypeMax = 255;


export const droneCommanderDroneModelsCreateBody = zod.object({
  "manufacturer": zod.string().max(droneCommanderDroneModelsCreateBodyManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsCreateBodyNameMax),
  "type": zod.string().max(droneCommanderDroneModelsCreateBodyTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish()
})


export const droneCommanderDroneModelsReadResponseManufacturerMax = 255;
export const droneCommanderDroneModelsReadResponseNameMax = 255;
export const droneCommanderDroneModelsReadResponseTypeMax = 255;


export const droneCommanderDroneModelsReadResponse = zod.object({
  "id": zod.number().optional(),
  "manufacturer": zod.string().max(droneCommanderDroneModelsReadResponseManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsReadResponseNameMax),
  "type": zod.string().max(droneCommanderDroneModelsReadResponseTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


export const droneCommanderDroneModelsUpdateBodyManufacturerMax = 255;
export const droneCommanderDroneModelsUpdateBodyNameMax = 255;
export const droneCommanderDroneModelsUpdateBodyTypeMax = 255;


export const droneCommanderDroneModelsUpdateBody = zod.object({
  "manufacturer": zod.string().max(droneCommanderDroneModelsUpdateBodyManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsUpdateBodyNameMax),
  "type": zod.string().max(droneCommanderDroneModelsUpdateBodyTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish()
})

export const droneCommanderDroneModelsUpdateResponseManufacturerMax = 255;
export const droneCommanderDroneModelsUpdateResponseNameMax = 255;
export const droneCommanderDroneModelsUpdateResponseTypeMax = 255;


export const droneCommanderDroneModelsUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "manufacturer": zod.string().max(droneCommanderDroneModelsUpdateResponseManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsUpdateResponseNameMax),
  "type": zod.string().max(droneCommanderDroneModelsUpdateResponseTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


export const droneCommanderDroneModelsPartialUpdateBodyManufacturerMax = 255;
export const droneCommanderDroneModelsPartialUpdateBodyNameMax = 255;
export const droneCommanderDroneModelsPartialUpdateBodyTypeMax = 255;


export const droneCommanderDroneModelsPartialUpdateBody = zod.object({
  "manufacturer": zod.string().max(droneCommanderDroneModelsPartialUpdateBodyManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsPartialUpdateBodyNameMax),
  "type": zod.string().max(droneCommanderDroneModelsPartialUpdateBodyTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish()
})

export const droneCommanderDroneModelsPartialUpdateResponseManufacturerMax = 255;
export const droneCommanderDroneModelsPartialUpdateResponseNameMax = 255;
export const droneCommanderDroneModelsPartialUpdateResponseTypeMax = 255;


export const droneCommanderDroneModelsPartialUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "manufacturer": zod.string().max(droneCommanderDroneModelsPartialUpdateResponseManufacturerMax).nullish(),
  "name": zod.string().min(1).max(droneCommanderDroneModelsPartialUpdateResponseNameMax),
  "type": zod.string().max(droneCommanderDroneModelsPartialUpdateResponseTypeMax).nullish(),
  "description": zod.string().nullish(),
  "configuration": zod.string().nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional()
})


/**
 * Fetch a DroneProfile using its unique EID.
 * @summary Retrieve a DroneProfile by EID
 */
export const droneCommanderGetByEidParams = zod.object({
  "eid": zod.string().describe('Unique EID for the DroneProfile')
})

export const droneCommanderGetByEidResponseNameMax = 100;
export const droneCommanderGetByEidResponseBatteryInfoBatteryTypeMax = 100;
export const droneCommanderGetByEidResponseBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderGetByEidResponseMacAddressMax = 100;
export const droneCommanderGetByEidResponseEidMax = 100;


export const droneCommanderGetByEidResponse = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(droneCommanderGetByEidResponseNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderGetByEidResponseBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderGetByEidResponseBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderGetByEidResponseMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "drone_model_name": zod.string().min(1).optional(),
  "eid": zod.string().min(1).max(droneCommanderGetByEidResponseEidMax),
  "device_uuid": zod.uuid().nullish()
})


export const droneCommanderDroneProfilesListResponseNameMax = 100;
export const droneCommanderDroneProfilesListResponseBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesListResponseBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesListResponseMacAddressMax = 100;
export const droneCommanderDroneProfilesListResponseEidMax = 100;


export const droneCommanderDroneProfilesListResponseItem = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(droneCommanderDroneProfilesListResponseNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesListResponseBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesListResponseBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesListResponseMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "drone_model_name": zod.string().min(1).optional(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesListResponseEidMax),
  "device_uuid": zod.uuid().nullish()
})
export const droneCommanderDroneProfilesListResponse = zod.array(droneCommanderDroneProfilesListResponseItem)


export const droneCommanderDroneProfilesCreateBodyNameMax = 100;
export const droneCommanderDroneProfilesCreateBodyBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesCreateBodyBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesCreateBodyMacAddressMax = 100;
export const droneCommanderDroneProfilesCreateBodyEidMax = 100;


export const droneCommanderDroneProfilesCreateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderDroneProfilesCreateBodyNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesCreateBodyBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesCreateBodyBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesCreateBodyMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesCreateBodyEidMax),
  "device_uuid": zod.uuid().nullish()
})


/**
 * This API allows you to delete multiple DroneProfile instances by passing their IDs in the request body.
 * @summary Delete multiple DroneProfile instances by their IDs
 */
export const droneCommanderDroneProfilesBulkRemoveDroneprofilesBody = zod.object({
  "ids": zod.array(zod.number()).describe('List of DroneProfile IDs to delete')
})


export const droneCommanderDroneProfilesReadResponseNameMax = 100;
export const droneCommanderDroneProfilesReadResponseBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesReadResponseBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesReadResponseMacAddressMax = 100;
export const droneCommanderDroneProfilesReadResponseEidMax = 100;


export const droneCommanderDroneProfilesReadResponse = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(droneCommanderDroneProfilesReadResponseNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesReadResponseBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesReadResponseBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesReadResponseMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "drone_model_name": zod.string().min(1).optional(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesReadResponseEidMax),
  "device_uuid": zod.uuid().nullish()
})


export const droneCommanderDroneProfilesUpdateBodyNameMax = 100;
export const droneCommanderDroneProfilesUpdateBodyBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesUpdateBodyBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesUpdateBodyMacAddressMax = 100;
export const droneCommanderDroneProfilesUpdateBodyEidMax = 100;


export const droneCommanderDroneProfilesUpdateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderDroneProfilesUpdateBodyNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesUpdateBodyBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesUpdateBodyBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesUpdateBodyMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesUpdateBodyEidMax),
  "device_uuid": zod.uuid().nullish()
})

export const droneCommanderDroneProfilesUpdateResponseNameMax = 100;
export const droneCommanderDroneProfilesUpdateResponseBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesUpdateResponseBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesUpdateResponseMacAddressMax = 100;
export const droneCommanderDroneProfilesUpdateResponseEidMax = 100;


export const droneCommanderDroneProfilesUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(droneCommanderDroneProfilesUpdateResponseNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesUpdateResponseBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesUpdateResponseBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesUpdateResponseMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "drone_model_name": zod.string().min(1).optional(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesUpdateResponseEidMax),
  "device_uuid": zod.uuid().nullish()
})


export const droneCommanderDroneProfilesPartialUpdateBodyNameMax = 100;
export const droneCommanderDroneProfilesPartialUpdateBodyBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesPartialUpdateBodyBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesPartialUpdateBodyMacAddressMax = 100;
export const droneCommanderDroneProfilesPartialUpdateBodyEidMax = 100;


export const droneCommanderDroneProfilesPartialUpdateBody = zod.object({
  "name": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateBodyNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateBodyBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateBodyBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesPartialUpdateBodyMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateBodyEidMax),
  "device_uuid": zod.uuid().nullish()
})

export const droneCommanderDroneProfilesPartialUpdateResponseNameMax = 100;
export const droneCommanderDroneProfilesPartialUpdateResponseBatteryInfoBatteryTypeMax = 100;
export const droneCommanderDroneProfilesPartialUpdateResponseBatteryInfoBatteryModelNumberMax = 100;
export const droneCommanderDroneProfilesPartialUpdateResponseMacAddressMax = 100;
export const droneCommanderDroneProfilesPartialUpdateResponseEidMax = 100;


export const droneCommanderDroneProfilesPartialUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "name": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateResponseNameMax),
  "ip_address": zod.string().min(1).nullish(),
  "flight_operations_site": zod.number().nullish(),
  "organization": zod.number(),
  "battery_info": zod.object({
  "id": zod.number().optional(),
  "battery_capacity": zod.number().describe('in mAh'),
  "battery_type": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateResponseBatteryInfoBatteryTypeMax),
  "battery_model_number": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateResponseBatteryInfoBatteryModelNumberMax),
  "battery_backup": zod.number().describe('percentage')
}).nullish(),
  "performance_characteristics": zod.object({
  "id": zod.number().optional(),
  "maximum_speed": zod.number().describe('in meters per second'),
  "maximum_altitude": zod.number().describe('in meters'),
  "maximum_range": zod.number().describe('in kilometers'),
  "flight_time": zod.number().describe('in minutes')
}).nullish(),
  "mac_address": zod.string().max(droneCommanderDroneProfilesPartialUpdateResponseMacAddressMax).nullish(),
  "sensors": zod.string().nullish().describe('List of sensors and specifications'),
  "drone_model": zod.number(),
  "drone_model_name": zod.string().min(1).optional(),
  "eid": zod.string().min(1).max(droneCommanderDroneProfilesPartialUpdateResponseEidMax),
  "device_uuid": zod.uuid().nullish()
})


/**
 * Retrieve the latest heartbeat entry for a given drone_id.
 * @summary Get Latest Drone Heartbeat
 */
export const droneCommanderHeartbeatReadParams = zod.object({
  "drone_id": zod.number().describe('ID of the drone')
})

export const droneCommanderHeartbeatReadResponseDeviceUuidSourceMax = 50;
export const droneCommanderHeartbeatReadResponseInterruptsMin = -9223372036854776000;

export const droneCommanderHeartbeatReadResponseInterruptsMax = 9223372036854776000;
export const droneCommanderHeartbeatReadResponseUptimeSecondsMin = -2147483648;

export const droneCommanderHeartbeatReadResponseUptimeSecondsMax = 2147483647;
export const droneCommanderHeartbeatReadResponseBatteryPercentageMin = -2147483648;

export const droneCommanderHeartbeatReadResponseBatteryPercentageMax = 2147483647;
export const droneCommanderHeartbeatReadResponseConnectionTypeMax = 50;


export const droneCommanderHeartbeatReadResponse = zod.object({
  "id": zod.number().optional(),
  "timestamp": zod.iso.datetime({}),
  "device_uuid": zod.uuid().nullish(),
  "device_uuid_source": zod.string().max(droneCommanderHeartbeatReadResponseDeviceUuidSourceMax).nullish(),
  "ip_addresses": zod.object({

}).nullish(),
  "ip_eth0": zod.object({

}).nullish(),
  "ip_wlan0": zod.object({

}).nullish(),
  "ip_docker0": zod.object({

}).nullish(),
  "ip_br_ce35e312a760": zod.object({

}).nullish(),
  "ip_veth5c573f7": zod.object({

}).nullish(),
  "ip_wg0": zod.object({

}).nullish(),
  "cpu_temperature": zod.number().nullish(),
  "interrupts": zod.number().min(droneCommanderHeartbeatReadResponseInterruptsMin).max(droneCommanderHeartbeatReadResponseInterruptsMax).nullish(),
  "uptime_seconds": zod.number().min(droneCommanderHeartbeatReadResponseUptimeSecondsMin).max(droneCommanderHeartbeatReadResponseUptimeSecondsMax).nullish(),
  "battery_percentage": zod.number().min(droneCommanderHeartbeatReadResponseBatteryPercentageMin).max(droneCommanderHeartbeatReadResponseBatteryPercentageMax).nullish(),
  "cpu_load": zod.object({

}).nullish(),
  "memory": zod.object({

}).nullish(),
  "disk_io": zod.object({

}).nullish(),
  "network_usage": zod.object({

}).nullish(),
  "packet_statistics": zod.object({

}).nullish(),
  "nodes_metrics": zod.object({

}).nullish(),
  "connection_type": zod.string().max(droneCommanderHeartbeatReadResponseConnectionTypeMax).nullish().describe('Type of connection (e.g., 4G, 5G, WiFi, Ethernet)'),
  "raw_json": zod.object({

}).nullish(),
  "created_at": zod.iso.datetime({}).optional(),
  "drone": zod.number().nullish(),
  "device": zod.uuid().nullish()
})


export const droneCommanderManufacturersListResponseAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersListResponseAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersListResponseAddressCityMax = 255;
export const droneCommanderManufacturersListResponseAddressZipCodeMax = 20;
export const droneCommanderManufacturersListResponseAddressStateMax = 255;
export const droneCommanderManufacturersListResponseAddressCountryMax = 255;
export const droneCommanderManufacturersListResponseNameMax = 255;
export const droneCommanderManufacturersListResponseWebsiteMax = 255;
export const droneCommanderManufacturersListResponseEmailMax = 255;
export const droneCommanderManufacturersListResponsePhoneNumberMax = 20;


export const droneCommanderManufacturersListResponseItem = zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersListResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersListResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersListResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersListResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersListResponseAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersListResponseAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersListResponseNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersListResponseWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersListResponseEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersListResponsePhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "logo": zod.url().nullish(),
  "is_active": zod.boolean().optional()
})
export const droneCommanderManufacturersListResponse = zod.array(droneCommanderManufacturersListResponseItem)


export const droneCommanderManufacturersCreateBodyAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersCreateBodyAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersCreateBodyAddressCityMax = 255;
export const droneCommanderManufacturersCreateBodyAddressZipCodeMax = 20;
export const droneCommanderManufacturersCreateBodyAddressStateMax = 255;
export const droneCommanderManufacturersCreateBodyAddressCountryMax = 255;
export const droneCommanderManufacturersCreateBodyNameMax = 255;
export const droneCommanderManufacturersCreateBodyWebsiteMax = 255;
export const droneCommanderManufacturersCreateBodyEmailMax = 255;
export const droneCommanderManufacturersCreateBodyPhoneNumberMax = 20;


export const droneCommanderManufacturersCreateBody = zod.object({
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersCreateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersCreateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersCreateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersCreateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersCreateBodyAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersCreateBodyAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersCreateBodyNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersCreateBodyWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersCreateBodyEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersCreateBodyPhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "is_active": zod.boolean().optional()
})


export const droneCommanderManufacturersReadResponseAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersReadResponseAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersReadResponseAddressCityMax = 255;
export const droneCommanderManufacturersReadResponseAddressZipCodeMax = 20;
export const droneCommanderManufacturersReadResponseAddressStateMax = 255;
export const droneCommanderManufacturersReadResponseAddressCountryMax = 255;
export const droneCommanderManufacturersReadResponseNameMax = 255;
export const droneCommanderManufacturersReadResponseWebsiteMax = 255;
export const droneCommanderManufacturersReadResponseEmailMax = 255;
export const droneCommanderManufacturersReadResponsePhoneNumberMax = 20;


export const droneCommanderManufacturersReadResponse = zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersReadResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersReadResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersReadResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersReadResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersReadResponseAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersReadResponseAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersReadResponseNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersReadResponseWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersReadResponseEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersReadResponsePhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "logo": zod.url().nullish(),
  "is_active": zod.boolean().optional()
})


export const droneCommanderManufacturersUpdateBodyAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersUpdateBodyAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersUpdateBodyAddressCityMax = 255;
export const droneCommanderManufacturersUpdateBodyAddressZipCodeMax = 20;
export const droneCommanderManufacturersUpdateBodyAddressStateMax = 255;
export const droneCommanderManufacturersUpdateBodyAddressCountryMax = 255;
export const droneCommanderManufacturersUpdateBodyNameMax = 255;
export const droneCommanderManufacturersUpdateBodyWebsiteMax = 255;
export const droneCommanderManufacturersUpdateBodyEmailMax = 255;
export const droneCommanderManufacturersUpdateBodyPhoneNumberMax = 20;


export const droneCommanderManufacturersUpdateBody = zod.object({
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersUpdateBodyAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersUpdateBodyNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersUpdateBodyWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersUpdateBodyEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersUpdateBodyPhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "is_active": zod.boolean().optional()
})

export const droneCommanderManufacturersUpdateResponseAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersUpdateResponseAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersUpdateResponseAddressCityMax = 255;
export const droneCommanderManufacturersUpdateResponseAddressZipCodeMax = 20;
export const droneCommanderManufacturersUpdateResponseAddressStateMax = 255;
export const droneCommanderManufacturersUpdateResponseAddressCountryMax = 255;
export const droneCommanderManufacturersUpdateResponseNameMax = 255;
export const droneCommanderManufacturersUpdateResponseWebsiteMax = 255;
export const droneCommanderManufacturersUpdateResponseEmailMax = 255;
export const droneCommanderManufacturersUpdateResponsePhoneNumberMax = 20;


export const droneCommanderManufacturersUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersUpdateResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersUpdateResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersUpdateResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersUpdateResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersUpdateResponseAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersUpdateResponseAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersUpdateResponseNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersUpdateResponseWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersUpdateResponseEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersUpdateResponsePhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "logo": zod.url().nullish(),
  "is_active": zod.boolean().optional()
})


export const droneCommanderManufacturersPartialUpdateBodyAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersPartialUpdateBodyAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersPartialUpdateBodyAddressCityMax = 255;
export const droneCommanderManufacturersPartialUpdateBodyAddressZipCodeMax = 20;
export const droneCommanderManufacturersPartialUpdateBodyAddressStateMax = 255;
export const droneCommanderManufacturersPartialUpdateBodyAddressCountryMax = 255;
export const droneCommanderManufacturersPartialUpdateBodyNameMax = 255;
export const droneCommanderManufacturersPartialUpdateBodyWebsiteMax = 255;
export const droneCommanderManufacturersPartialUpdateBodyEmailMax = 255;
export const droneCommanderManufacturersPartialUpdateBodyPhoneNumberMax = 20;


export const droneCommanderManufacturersPartialUpdateBody = zod.object({
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersPartialUpdateBodyAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersPartialUpdateBodyAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersPartialUpdateBodyAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersPartialUpdateBodyAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersPartialUpdateBodyAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersPartialUpdateBodyAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersPartialUpdateBodyNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersPartialUpdateBodyWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersPartialUpdateBodyEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersPartialUpdateBodyPhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "is_active": zod.boolean().optional()
})

export const droneCommanderManufacturersPartialUpdateResponseAddressStreetAddress1Max = 255;
export const droneCommanderManufacturersPartialUpdateResponseAddressStreetAddress2Max = 255;
export const droneCommanderManufacturersPartialUpdateResponseAddressCityMax = 255;
export const droneCommanderManufacturersPartialUpdateResponseAddressZipCodeMax = 20;
export const droneCommanderManufacturersPartialUpdateResponseAddressStateMax = 255;
export const droneCommanderManufacturersPartialUpdateResponseAddressCountryMax = 255;
export const droneCommanderManufacturersPartialUpdateResponseNameMax = 255;
export const droneCommanderManufacturersPartialUpdateResponseWebsiteMax = 255;
export const droneCommanderManufacturersPartialUpdateResponseEmailMax = 255;
export const droneCommanderManufacturersPartialUpdateResponsePhoneNumberMax = 20;


export const droneCommanderManufacturersPartialUpdateResponse = zod.object({
  "id": zod.number().optional(),
  "address": zod.object({
  "id": zod.number().optional(),
  "street_address_1": zod.string().max(droneCommanderManufacturersPartialUpdateResponseAddressStreetAddress1Max).nullish(),
  "street_address_2": zod.string().max(droneCommanderManufacturersPartialUpdateResponseAddressStreetAddress2Max).nullish(),
  "city": zod.string().max(droneCommanderManufacturersPartialUpdateResponseAddressCityMax).nullish(),
  "zip_code": zod.string().max(droneCommanderManufacturersPartialUpdateResponseAddressZipCodeMax).nullish(),
  "state": zod.string().max(droneCommanderManufacturersPartialUpdateResponseAddressStateMax).nullish(),
  "country": zod.string().max(droneCommanderManufacturersPartialUpdateResponseAddressCountryMax).nullish()
}),
  "name": zod.string().min(1).max(droneCommanderManufacturersPartialUpdateResponseNameMax),
  "founded_at": zod.iso.date().nullish(),
  "website": zod.url().max(droneCommanderManufacturersPartialUpdateResponseWebsiteMax).nullish(),
  "email": zod.email().max(droneCommanderManufacturersPartialUpdateResponseEmailMax).nullish(),
  "phone_number": zod.string().max(droneCommanderManufacturersPartialUpdateResponsePhoneNumberMax).nullish(),
  "description": zod.string().nullish(),
  "logo": zod.url().nullish(),
  "is_active": zod.boolean().optional()
})


/**
 * Retrieve a list of all missions for the authenticated user's organization.
 * @summary List Missions
 */
export const droneCommanderMissionsListResponseDataItemSequencesItemOrderDefault = 1;
export const droneCommanderMissionsListResponseDataItemSequencesItemOrderMin = -2147483648;

export const droneCommanderMissionsListResponseDataItemSequencesItemOrderMax = 2147483647;
export const droneCommanderMissionsListResponseDataItemSequencesItemStepsItemOrderMin = -2147483648;

export const droneCommanderMissionsListResponseDataItemSequencesItemStepsItemOrderMax = 2147483647;
export const droneCommanderMissionsListResponseDataItemSequencesItemStepsItemLabelMax = 120;
export const droneCommanderMissionsListResponseDataItemSequencesItemStepsItemCameraModeMax = 10;
export const droneCommanderMissionsListResponseDataItemNameMax = 200;


export const droneCommanderMissionsListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.uuid().optional(),
  "campaign": zod.string().optional(),
  "tags": zod.array(zod.uuid()).optional(),
  "sequences": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsListResponseDataItemSequencesItemOrderMin).max(droneCommanderMissionsListResponseDataItemSequencesItemOrderMax).default(droneCommanderMissionsListResponseDataItemSequencesItemOrderDefault),
  "steps": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsListResponseDataItemSequencesItemStepsItemOrderMin).max(droneCommanderMissionsListResponseDataItemSequencesItemStepsItemOrderMax),
  "label": zod.string().max(droneCommanderMissionsListResponseDataItemSequencesItemStepsItemLabelMax).nullish(),
  "speed_mps": zod.string().nullish(),
  "camera_mode": zod.string().max(droneCommanderMissionsListResponseDataItemSequencesItemStepsItemCameraModeMax).nullish(),
  "nav_kind": zod.enum(['TAKEOFF', 'WAYPOINT', 'RTH', 'ORBIT']).nullable(),
  "aux": zod.object({

}).nullish(),
  "lat": zod.number().optional(),
  "lon": zod.number().optional(),
  "alt_m": zod.number().optional(),
  "pitch": zod.number().nullish(),
  "hold_time": zod.number().nullish(),
  "accept_radius": zod.number().nullish(),
  "pass_radius": zod.number().nullish(),
  "yaw": zod.number().nullish(),
  "turns": zod.number().nullish()
}))
})).optional(),
  "name": zod.string().min(1).max(droneCommanderMissionsListResponseDataItemNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish()
}))
})


/**
 * Create a new mission with sequences and steps for drone operations. 
 * @summary Create Mission
 */
export const droneCommanderMissionsCreateMissionBodySequencesItemOrderDefault = 1;
export const droneCommanderMissionsCreateMissionBodySequencesItemOrderMin = -2147483648;

export const droneCommanderMissionsCreateMissionBodySequencesItemOrderMax = 2147483647;
export const droneCommanderMissionsCreateMissionBodySequencesItemStepsItemOrderMin = -2147483648;

export const droneCommanderMissionsCreateMissionBodySequencesItemStepsItemOrderMax = 2147483647;
export const droneCommanderMissionsCreateMissionBodySequencesItemStepsItemLabelMax = 120;
export const droneCommanderMissionsCreateMissionBodySequencesItemStepsItemCameraModeMax = 10;


export const droneCommanderMissionsCreateMissionBody = zod.object({
  "name": zod.string().min(1).describe('Mission name'),
  "description": zod.string().min(1).optional().describe('Mission description'),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional().describe('Mission status'),
  "campaign": zod.uuid().optional().describe('Campaign ID'),
  "cruise_speed": zod.number().optional().describe('Cruise speed in m/s'),
  "hover_speed": zod.number().optional().describe('Hover speed in m/s'),
  "geofence_inclusion": zod.boolean().optional().describe('Geofence inclusion flag'),
  "sequences": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsCreateMissionBodySequencesItemOrderMin).max(droneCommanderMissionsCreateMissionBodySequencesItemOrderMax).default(droneCommanderMissionsCreateMissionBodySequencesItemOrderDefault),
  "steps": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsCreateMissionBodySequencesItemStepsItemOrderMin).max(droneCommanderMissionsCreateMissionBodySequencesItemStepsItemOrderMax),
  "label": zod.string().max(droneCommanderMissionsCreateMissionBodySequencesItemStepsItemLabelMax).nullish(),
  "speed_mps": zod.string().nullish(),
  "camera_mode": zod.string().max(droneCommanderMissionsCreateMissionBodySequencesItemStepsItemCameraModeMax).nullish(),
  "nav_kind": zod.enum(['TAKEOFF', 'WAYPOINT', 'RTH', 'ORBIT']).nullable(),
  "aux": zod.object({

}).nullish(),
  "lat": zod.number().optional(),
  "lon": zod.number().optional(),
  "alt_m": zod.number().optional(),
  "pitch": zod.number().nullish(),
  "hold_time": zod.number().nullish(),
  "accept_radius": zod.number().nullish(),
  "pass_radius": zod.number().nullish(),
  "yaw": zod.number().nullish(),
  "turns": zod.number().nullish()
}))
})).describe('Mission sequences')
})


/**
 * Retrieve a specific mission by ID.
 * @summary Retrieve Mission
 */
export const droneCommanderMissionsReadResponseDataSequencesItemOrderDefault = 1;
export const droneCommanderMissionsReadResponseDataSequencesItemOrderMin = -2147483648;

export const droneCommanderMissionsReadResponseDataSequencesItemOrderMax = 2147483647;
export const droneCommanderMissionsReadResponseDataSequencesItemStepsItemOrderMin = -2147483648;

export const droneCommanderMissionsReadResponseDataSequencesItemStepsItemOrderMax = 2147483647;
export const droneCommanderMissionsReadResponseDataSequencesItemStepsItemLabelMax = 120;
export const droneCommanderMissionsReadResponseDataSequencesItemStepsItemCameraModeMax = 10;
export const droneCommanderMissionsReadResponseDataNameMax = 200;


export const droneCommanderMissionsReadResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "campaign": zod.string().optional(),
  "tags": zod.array(zod.uuid()).optional(),
  "sequences": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsReadResponseDataSequencesItemOrderMin).max(droneCommanderMissionsReadResponseDataSequencesItemOrderMax).default(droneCommanderMissionsReadResponseDataSequencesItemOrderDefault),
  "steps": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsReadResponseDataSequencesItemStepsItemOrderMin).max(droneCommanderMissionsReadResponseDataSequencesItemStepsItemOrderMax),
  "label": zod.string().max(droneCommanderMissionsReadResponseDataSequencesItemStepsItemLabelMax).nullish(),
  "speed_mps": zod.string().nullish(),
  "camera_mode": zod.string().max(droneCommanderMissionsReadResponseDataSequencesItemStepsItemCameraModeMax).nullish(),
  "nav_kind": zod.enum(['TAKEOFF', 'WAYPOINT', 'RTH', 'ORBIT']).nullable(),
  "aux": zod.object({

}).nullish(),
  "lat": zod.number().optional(),
  "lon": zod.number().optional(),
  "alt_m": zod.number().optional(),
  "pitch": zod.number().nullish(),
  "hold_time": zod.number().nullish(),
  "accept_radius": zod.number().nullish(),
  "pass_radius": zod.number().nullish(),
  "yaw": zod.number().nullish(),
  "turns": zod.number().nullish()
}))
})).optional(),
  "name": zod.string().min(1).max(droneCommanderMissionsReadResponseDataNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish()
})
})


/**
 * Update an existing mission completely.
 * @summary Update Mission
 */
export const droneCommanderMissionsUpdateBodyNameMax = 200;


export const droneCommanderMissionsUpdateBody = zod.object({
  "tags": zod.array(zod.uuid()).optional(),
  "name": zod.string().min(1).max(droneCommanderMissionsUpdateBodyNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish()
})

export const droneCommanderMissionsUpdateResponseDataSequencesItemOrderDefault = 1;
export const droneCommanderMissionsUpdateResponseDataSequencesItemOrderMin = -2147483648;

export const droneCommanderMissionsUpdateResponseDataSequencesItemOrderMax = 2147483647;
export const droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemOrderMin = -2147483648;

export const droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemOrderMax = 2147483647;
export const droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemLabelMax = 120;
export const droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemCameraModeMax = 10;
export const droneCommanderMissionsUpdateResponseDataNameMax = 200;


export const droneCommanderMissionsUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "campaign": zod.string().optional(),
  "tags": zod.array(zod.uuid()).optional(),
  "sequences": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsUpdateResponseDataSequencesItemOrderMin).max(droneCommanderMissionsUpdateResponseDataSequencesItemOrderMax).default(droneCommanderMissionsUpdateResponseDataSequencesItemOrderDefault),
  "steps": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemOrderMin).max(droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemOrderMax),
  "label": zod.string().max(droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemLabelMax).nullish(),
  "speed_mps": zod.string().nullish(),
  "camera_mode": zod.string().max(droneCommanderMissionsUpdateResponseDataSequencesItemStepsItemCameraModeMax).nullish(),
  "nav_kind": zod.enum(['TAKEOFF', 'WAYPOINT', 'RTH', 'ORBIT']).nullable(),
  "aux": zod.object({

}).nullish(),
  "lat": zod.number().optional(),
  "lon": zod.number().optional(),
  "alt_m": zod.number().optional(),
  "pitch": zod.number().nullish(),
  "hold_time": zod.number().nullish(),
  "accept_radius": zod.number().nullish(),
  "pass_radius": zod.number().nullish(),
  "yaw": zod.number().nullish(),
  "turns": zod.number().nullish()
}))
})).optional(),
  "name": zod.string().min(1).max(droneCommanderMissionsUpdateResponseDataNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish()
})
})


/**
 * Partially update an existing mission.
 * @summary Partial Update Mission
 */
export const droneCommanderMissionsPartialUpdateBodyNameMax = 200;


export const droneCommanderMissionsPartialUpdateBody = zod.object({
  "tags": zod.array(zod.uuid()).optional(),
  "name": zod.string().min(1).max(droneCommanderMissionsPartialUpdateBodyNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish()
})

export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemOrderDefault = 1;
export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemOrderMin = -2147483648;

export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemOrderMax = 2147483647;
export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemOrderMin = -2147483648;

export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemOrderMax = 2147483647;
export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemLabelMax = 120;
export const droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemCameraModeMax = 10;
export const droneCommanderMissionsPartialUpdateResponseDataNameMax = 200;


export const droneCommanderMissionsPartialUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "campaign": zod.string().optional(),
  "tags": zod.array(zod.uuid()).optional(),
  "sequences": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsPartialUpdateResponseDataSequencesItemOrderMin).max(droneCommanderMissionsPartialUpdateResponseDataSequencesItemOrderMax).default(droneCommanderMissionsPartialUpdateResponseDataSequencesItemOrderDefault),
  "steps": zod.array(zod.object({
  "order": zod.number().min(droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemOrderMin).max(droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemOrderMax),
  "label": zod.string().max(droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemLabelMax).nullish(),
  "speed_mps": zod.string().nullish(),
  "camera_mode": zod.string().max(droneCommanderMissionsPartialUpdateResponseDataSequencesItemStepsItemCameraModeMax).nullish(),
  "nav_kind": zod.enum(['TAKEOFF', 'WAYPOINT', 'RTH', 'ORBIT']).nullable(),
  "aux": zod.object({

}).nullish(),
  "lat": zod.number().optional(),
  "lon": zod.number().optional(),
  "alt_m": zod.number().optional(),
  "pitch": zod.number().nullish(),
  "hold_time": zod.number().nullish(),
  "accept_radius": zod.number().nullish(),
  "pass_radius": zod.number().nullish(),
  "yaw": zod.number().nullish(),
  "turns": zod.number().nullish()
}))
})).optional(),
  "name": zod.string().min(1).max(droneCommanderMissionsPartialUpdateResponseDataNameMax),
  "description": zod.string().nullish(),
  "status": zod.enum(['pending', 'active', 'completed', 'failed', 'cancelled']).optional(),
  "started_at": zod.iso.datetime({}).nullish(),
  "ended_at": zod.iso.datetime({}).nullish(),
  "cruise_speed": zod.string().optional(),
  "hover_speed": zod.string().optional(),
  "planned_home_lat": zod.string().nullish(),
  "planned_home_lon": zod.string().nullish(),
  "planned_home_alt": zod.string().nullish(),
  "geofence_inclusion": zod.boolean().optional(),
  "organization": zod.number().nullish()
})
})


/**
 * Return the mission in QGroundControl (QGC) JSON format for the given mission ID.
 * @summary Get Mission in QGC format
 */
export const droneCommanderMissionsQgcResponseDataPayloadMissionItemsItemParamsMin = 7;

export const droneCommanderMissionsQgcResponseDataPayloadMissionItemsItemParamsMax = 7;
export const droneCommanderMissionsQgcResponseDataPayloadMissionPlannedHomePositionMin = 3;

export const droneCommanderMissionsQgcResponseDataPayloadMissionPlannedHomePositionMax = 3;


export const droneCommanderMissionsQgcResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "payload": zod.object({
  "fileType": zod.string().min(1),
  "geoFence": zod.object({
  "circles": zod.array(zod.record(zod.string(), zod.string().nullable())),
  "polygons": zod.array(zod.record(zod.string(), zod.string().nullable())),
  "version": zod.number()
}),
  "groundStation": zod.string().min(1),
  "mission": zod.object({
  "cruiseSpeed": zod.number(),
  "firmwareType": zod.number(),
  "globalPlanAltitudeMode": zod.number(),
  "hoverSpeed": zod.number(),
  "items": zod.array(zod.object({
  "autoContinue": zod.boolean(),
  "command": zod.number(),
  "doJumpId": zod.number(),
  "frame": zod.number(),
  "type": zod.string().min(1),
  "params": zod.array(zod.number()).min(droneCommanderMissionsQgcResponseDataPayloadMissionItemsItemParamsMin).max(droneCommanderMissionsQgcResponseDataPayloadMissionItemsItemParamsMax),
  "Altitude": zod.number().nullish(),
  "AltitudeMode": zod.number().optional(),
  "AMSLAltAboveTerrain": zod.number().nullish()
})),
  "plannedHomePosition": zod.array(zod.number()).min(droneCommanderMissionsQgcResponseDataPayloadMissionPlannedHomePositionMin).max(droneCommanderMissionsQgcResponseDataPayloadMissionPlannedHomePositionMax),
  "vehicleType": zod.number(),
  "version": zod.number()
}),
  "rallyPoints": zod.object({
  "points": zod.array(zod.record(zod.string(), zod.string().nullable())),
  "version": zod.number()
}),
  "version": zod.number()
}).describe('Mission in QGroundControl format')
})
})


/**
 * Fetch the available multispectral index choices for drones.
 * @summary Retrieve Multispectral Index Choices
 */
export const droneCommanderMultispectralIndexChoicesListResponse = zod.object({
  "status": zod.number().optional().describe('HTTP status code'),
  "message": zod.string().optional().describe('Success message'),
  "data": zod.array(zod.object({
  "value": zod.string().optional().describe('Choice value'),
  "label": zod.string().optional().describe('Choice label')
})).optional()
})


/**
 * Executes the check_drone_status.sh script on the host to get current IP and service status.
 * @summary Check Drone Status
 */
export const droneCommanderWindscreenStatusListResponse = zod.object({
  "status": zod.number().optional().describe('HTTP status code'),
  "message": zod.string().optional().describe('Success message'),
  "data": zod.object({
  "current_ip": zod.string().optional().describe('Current IP address of the drone'),
  "service_status": zod.string().optional().describe('Status of the windscreen service')
}).optional()
})


/**
 * Executes the update_drone_ip.sh script on the host to update the drone's IP address.
 * @summary Update Drone IP
 */
export const droneCommanderWindscreenUpdateIpCreateBody = zod.object({
  "ip_address": zod.string().describe('New IP address for the drone')
})

export const droneCommanderWindscreenUpdateIpCreateResponse = zod.object({
  "status": zod.number().optional().describe('HTTP status code'),
  "message": zod.string().optional().describe('Success message'),
  "data": zod.object({
  "output": zod.string().optional().describe('Script output')
}).optional()
})


/**
 * @summary Associate a partner with a device and ensure EMQX republish rule
 */
export const integrationsDevicePartnerAssociateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "rule_id": zod.string().optional(),
  "already_associated": zod.boolean().optional()
})
})


/**
 * @summary Disassociate a partner from a device and clean up EMQX republish rule
 */
export const integrationsDevicePartnerDisassociateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "success": zod.boolean()
})
})


/**
 * @summary Start a provider integration session
 */
export const integrationsSessionsStartBodyPilotEmailMax = 128;
export const integrationsSessionsStartBodyDeviceIdMax = 128;
export const integrationsSessionsStartBodySessionTtlSecDefault = 900;
export const integrationsSessionsStartBodySessionTtlSecMin = 60;


export const integrationsSessionsStartBody = zod.object({
  "provider": zod.enum(['dronesense', 'other']),
  "pilot_email": zod.string().min(1).max(integrationsSessionsStartBodyPilotEmailMax),
  "device_id": zod.string().min(1).max(integrationsSessionsStartBodyDeviceIdMax),
  "session_ttl_sec": zod.number().min(integrationsSessionsStartBodySessionTtlSecMin).default(integrationsSessionsStartBodySessionTtlSecDefault)
})

export const integrationsSessionsStartResponseDataSourceDroneIdMax = 64;
export const integrationsSessionsStartResponseDataPilotEmailMax = 256;
export const integrationsSessionsStartResponseDataMqttUsernameMax = 128;


export const integrationsSessionsStartResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "device": zod.uuid(),
  "device_serial_number": zod.string().min(1).optional(),
  "provider": zod.enum(['dronesense', 'other']),
  "source_drone_id": zod.string().min(1).max(integrationsSessionsStartResponseDataSourceDroneIdMax),
  "pilot_email": zod.string().min(1).max(integrationsSessionsStartResponseDataPilotEmailMax),
  "mqtt_username": zod.string().min(1).max(integrationsSessionsStartResponseDataMqttUsernameMax),
  "expires_at": zod.iso.datetime({}),
  "ended_at": zod.iso.datetime({}).nullish(),
  "is_active": zod.boolean().optional(),
  "last_activity": zod.iso.datetime({}).nullish(),
  "metadata": zod.object({

}).nullish(),
  "created_at": zod.iso.datetime({}).optional()
})
})


/**
 * @summary Stop a provider integration session
 */
export const integrationsSessionsStopBodyDeviceIdMax = 128;


export const integrationsSessionsStopBody = zod.object({
  "provider": zod.enum(['dronesense', 'other']),
  "device_id": zod.string().min(1).max(integrationsSessionsStopBodyDeviceIdMax)
})

export const integrationsSessionsStopResponseDataSourceDroneIdMax = 64;
export const integrationsSessionsStopResponseDataPilotEmailMax = 256;
export const integrationsSessionsStopResponseDataMqttUsernameMax = 128;


export const integrationsSessionsStopResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.uuid().optional(),
  "device": zod.uuid(),
  "device_serial_number": zod.string().min(1).optional(),
  "provider": zod.enum(['dronesense', 'other']),
  "source_drone_id": zod.string().min(1).max(integrationsSessionsStopResponseDataSourceDroneIdMax),
  "pilot_email": zod.string().min(1).max(integrationsSessionsStopResponseDataPilotEmailMax),
  "mqtt_username": zod.string().min(1).max(integrationsSessionsStopResponseDataMqttUsernameMax),
  "expires_at": zod.iso.datetime({}),
  "ended_at": zod.iso.datetime({}).nullish(),
  "is_active": zod.boolean().optional(),
  "last_activity": zod.iso.datetime({}).nullish(),
  "metadata": zod.object({

}).nullish(),
  "created_at": zod.iso.datetime({}).optional()
})
})


/**
 * Returns the Janus room ID and all active streams for a specific campaign.
 * @summary Get active streams for a campaign
 */
export const videostreamhubCampaignStreamsListResponse = zod.object({
  "janus_room_id": zod.number().optional().describe('Janus room ID'),
  "streams": zod.array(zod.object({
  "id": zod.number().optional(),
  "task_id": zod.string().optional(),
  "room_id": zod.number().optional(),
  "stream_url": zod.string().optional(),
  "display_name": zod.string().optional(),
  "status": zod.string().optional(),
  "video_metadata": zod.object({

}).optional(),
  "metadata": zod.object({

}).optional()
}).describe('Active stream details')).optional().describe('List of active streams')
})


/**
 * API endpoint for stopping a stream.
 */
export const videostreamhubStopStreamCreateBody = zod.object({
  "stream_id": zod.string().describe('ID of the stream to stop')
})


/**
 * Retrieve a list of all video servers with optional filtering
 * @summary List all video servers
 */
export const videostreamhubVideoServersListResponseDataItemIdMax = 100;
export const videostreamhubVideoServersListResponseDataItemRegionMax = 100;
export const videostreamhubVideoServersListResponseDataItemWhepUrlMax = 500;


export const videostreamhubVideoServersListResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.array(zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersListResponseDataItemIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "region": zod.string().min(1).max(videostreamhubVideoServersListResponseDataItemRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersListResponseDataItemWhepUrlMax).describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server'),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "created_by": zod.number().nullish().describe('User who created this server entry'),
  "updated_by": zod.number().nullish().describe('User who last updated this server entry')
}))
})


/**
 * Add a new video server to the system
 * @summary Create a new video server
 */
export const videostreamhubVideoServersCreateBodyIdMax = 100;
export const videostreamhubVideoServersCreateBodyRegionMax = 100;
export const videostreamhubVideoServersCreateBodyWhepUrlMax = 500;


export const videostreamhubVideoServersCreateBody = zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersCreateBodyIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "region": zod.string().min(1).max(videostreamhubVideoServersCreateBodyRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersCreateBodyWhepUrlMax).describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server')
})


/**
 * Trigger an immediate broadcast of the video server list to MQTT. This endpoint is useful when you need to ensure all clients have the latest server list without waiting for the next scheduled broadcast. The message is published with retention enabled, so any drones connecting later will also receive this update.
 * @summary Manually trigger broadcast
 */
export const videostreamhubVideoServersBroadcastBodyIdMax = 100;
export const videostreamhubVideoServersBroadcastBodyRegionMax = 100;
export const videostreamhubVideoServersBroadcastBodyWhepUrlMax = 500;


export const videostreamhubVideoServersBroadcastBody = zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersBroadcastBodyIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "region": zod.string().min(1).max(videostreamhubVideoServersBroadcastBodyRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersBroadcastBodyWhepUrlMax).describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server')
})

export const videostreamhubVideoServersBroadcastResponse = zod.object({
  "status": zod.enum(['success', 'queued', 'success_after_retry']),
  "server_count": zod.number(),
  "updated_at": zod.string().min(1),
  "message_id": zod.number().nullish()
})


/**
 * Retrieve only enabled video servers (same format as broadcast payload)
 * @summary List enabled video servers
 */
export const videostreamhubVideoServersEnabledResponseServersItemIdMax = 100;
export const videostreamhubVideoServersEnabledResponseServersItemRegionMax = 100;


export const videostreamhubVideoServersEnabledResponse = zod.object({
  "count": zod.number(),
  "servers": zod.array(zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersEnabledResponseServersItemIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "url": zod.url().min(1),
  "region": zod.string().min(1).max(videostreamhubVideoServersEnabledResponseServersItemRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')')
}))
})


/**
 * Get details of a specific video server by ID
 * @summary Retrieve a video server
 */
export const videostreamhubVideoServersReadResponseDataIdMax = 100;
export const videostreamhubVideoServersReadResponseDataRegionMax = 100;
export const videostreamhubVideoServersReadResponseDataWhepUrlMax = 500;


export const videostreamhubVideoServersReadResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersReadResponseDataIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "region": zod.string().min(1).max(videostreamhubVideoServersReadResponseDataRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersReadResponseDataWhepUrlMax).describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server'),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "created_by": zod.number().nullish().describe('User who created this server entry'),
  "updated_by": zod.number().nullish().describe('User who last updated this server entry')
})
})


/**
 * Update all fields of a video server
 * @summary Update a video server
 */
export const videostreamhubVideoServersUpdateBodyRegionMax = 100;
export const videostreamhubVideoServersUpdateBodyWhepUrlMax = 500;


export const videostreamhubVideoServersUpdateBody = zod.object({
  "region": zod.string().min(1).max(videostreamhubVideoServersUpdateBodyRegionMax).optional().describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersUpdateBodyWhepUrlMax).optional().describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server')
})

export const videostreamhubVideoServersUpdateResponseDataIdMax = 100;
export const videostreamhubVideoServersUpdateResponseDataRegionMax = 100;
export const videostreamhubVideoServersUpdateResponseDataWhepUrlMax = 500;


export const videostreamhubVideoServersUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersUpdateResponseDataIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "region": zod.string().min(1).max(videostreamhubVideoServersUpdateResponseDataRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersUpdateResponseDataWhepUrlMax).describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server'),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "created_by": zod.number().nullish().describe('User who created this server entry'),
  "updated_by": zod.number().nullish().describe('User who last updated this server entry')
})
})


/**
 * Update specific fields of a video server
 * @summary Partially update a video server
 */
export const videostreamhubVideoServersPartialUpdateBodyRegionMax = 100;
export const videostreamhubVideoServersPartialUpdateBodyWhepUrlMax = 500;


export const videostreamhubVideoServersPartialUpdateBody = zod.object({
  "region": zod.string().min(1).max(videostreamhubVideoServersPartialUpdateBodyRegionMax).optional().describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersPartialUpdateBodyWhepUrlMax).optional().describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server')
})

export const videostreamhubVideoServersPartialUpdateResponseDataIdMax = 100;
export const videostreamhubVideoServersPartialUpdateResponseDataRegionMax = 100;
export const videostreamhubVideoServersPartialUpdateResponseDataWhepUrlMax = 500;


export const videostreamhubVideoServersPartialUpdateResponse = zod.object({
  "status": zod.number(),
  "message": zod.string().min(1),
  "data": zod.object({
  "id": zod.string().min(1).max(videostreamhubVideoServersPartialUpdateResponseDataIdMax).describe('Unique identifier for the video server (e.g., \'vs-eu-1\')'),
  "region": zod.string().min(1).max(videostreamhubVideoServersPartialUpdateResponseDataRegionMax).describe('Geographic region of the server (e.g., \'eu-central\', \'us-east\')'),
  "whep_url": zod.url().min(1).max(videostreamhubVideoServersPartialUpdateResponseDataWhepUrlMax).describe('WHEP endpoint URL for the video server'),
  "enabled": zod.boolean().optional().describe('Whether this server is active and should be broadcast'),
  "description": zod.string().nullish().describe('Optional description or notes about this server'),
  "created_at": zod.iso.datetime({}).optional(),
  "updated_at": zod.iso.datetime({}).optional(),
  "created_by": zod.number().nullish().describe('User who created this server entry'),
  "updated_by": zod.number().nullish().describe('User who last updated this server entry')
})
})
